<template>
    <div class="foodmain">
<!-- /* Logged In Business user */ -->
        <div  v-if="$store.getters.user && $user.userType=='business' ">
          <AppBar />
        </div>

<!-- ###################### LEFT SIDE MENU SLIDE OUT MENU SETTINGS ###################### -->
<!-- /* Business Dashboard */ -->
<!-- Logged in Business Side Drawer Menu  -->


<!-- Logged in Business Side Drawer Menu -->

        <v-overlay v-model="overlayfooditem" z-index="99999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

        </v-overlay>
        <v-overlay v-model="orderoverlay" z-index="99999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

        </v-overlay>

        <v-overlay v-model="overlayfooditemimageupdate" z-index="99999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

        </v-overlay>


        <v-overlay v-model="overlayPIN" >
            <!-- <v-progress-circular indeterminate size="64"></v-progress-circular> -->
            <img :src="cocacolaImg" style="height:250px;max-width:auto !important;display:inline !important;"/>
        </v-overlay>

<!-- FOOD ##################### FOOD PAGE TOP LOGO AND ALLERGEN ICON ##################### -->
<!-- <v-card elevation-0 class="pa-0 ma-0 bgr pwa-container"> -->
        <v-card  class="pb-80" elevation=0 v-if="isloaded">
            <div class="">
                <v-row class="ma-0 business-logo-top-center">
                    <v-col cols="12" v-if="business.logo=='null' || business.logo=='null'">
                        <h2> {{business.businessName}}</h2>
                    </v-col>
                    <v-col cols="12" v-else>
                        <img :src="business.logo" class="business-logo-top-center" :alt="business.businessName"/>
                    </v-col>
                </v-row>
            </div>


            <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-0 mt-5" >
<!-- /* Filter for Allergens */ -->
                <div v-if="!filter && !filterAllergens">

                      <v-tabs height="32" v-sticky v-model="currentcourse" :color= business.themecolor   background-color="#fff" center-active show-arrows class="" >
                            <v-tab  v-for="(item, index) in business.fooditems" :key="'course-'+item[0].course_id"  class="" @click="setview(foodview,'foodgrid-'+item[0].course_id)" @change="setview(foodview,'foodgrid-'+item[0].course_id)">
                                <!-- {{ index }} -->
                                {{userlangcode==''?index:business.coursesmaster[index].languagetranslations[userlangcode].title}}
                            </v-tab>
<!-- STICKY HEADER --></v-tabs>


<v-tabs-items v-model="currentcourse">
                            <v-tab-item v-for="(item, index) in business.fooditems" :key="'course-'+item[0].course_id" class="pa-1" sticky-container >
                                <v-row  align="center"  style="background:#d4d4d4;" class="mb-3">
                                    <v-col cols="6" class="">
                                        <div class="fixed-course-heading">
                                            <!-- {{ index }} -->
                                            {{userlangcode==''?index:business.coursesmaster[index].languagetranslations[userlangcode].title}}
                                        </div>
                                    </v-col>
    <!-- ==============================================================  -->
    <!-- GRID & LIST VIEW ICONS TOOL BAR TO BE REMOVED BEFORE GOING LIVE  -->
                                    <v-col cols="2" class="mid-mid" v-if=" countActivelang==1">
                                        <!-- <v-icon v-if="foodview=='list'"
                                                class="grid-list-icons" @click="setview('grid','foodgrid-'+item[0].course_id)"
                                                color="#FE5800"
                                                size="18">mdi-grid-large
                                        </v-icon>
                                        <v-icon v-if="foodview=='grid'" class="grid-list-icons" @click="setview('list','foodgrid-'+item[0].course_id)"
                                            color="#FE5800"
                                            size="18">mdi-format-list-bulleted-square
                                        </v-icon> -->
                                        <v-menu class="" @click.native.stop  transition="fab-transition" v-if="business.hastranslations">
                                                        <template v-slot:activator="{ on, attrs }"
                                                        top
                                                        left
                                                        transition="scale-transition"
                                                        >
                                                            <v-btn @click.stop color="#FE5800" icon v-bind="attrs" v-on="on">
                                                                <v-avatar size="24" tile>
                                                                    <img :src="'https://api.juzzap.com/flags/4x3/'+userlangcode+'.svg'" />
                                                                </v-avatar>

                                                            </v-btn>
                                                        </template>

                                                        <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                            <v-list-item v-for="(lang,ind) in business.translationlanguages" :key="'tl-'+ind">
                                                                <a @click.prevent="setlangcode(lang.languagecode)">
                                                                  <div class="row">
                                                                  <div class="col-3"><img :src="lang.photo"  :alt="lang.languagecode" width="16"/></div>
                                                                  <div class="col-9">{{lang.lname+'('+lang.languagecode+')'}}</div>
                                                                </div>
                                                                </a>

                                                            </v-list-item>



                                                        </v-list>
                                                    </v-menu>
                                    </v-col>
    <!-- ==============================================================  -->
                                    <v-col cols="2" class="mid-mid">
                                        <span class="text-center">
                                            <a @click="filterAllergens=!filterAllergens">
                                                <v-row>
                                                    <img :src="allergenImg"  class="pulsex7 allergen-filter-icon">
                                                </v-row>
                                                <!-- <v-row class="allergen-filter-icon-label">
                                                    {{$t('zz_allergens')}}
                                                </v-row> -->
                                            </a>
                                        </span>
                                    </v-col>
                                    <v-col cols="2" class="mid-mid">
                                        <v-row
                                            color=""
                                            class=""
                                            @click="gotoorder">
                                            <v-avatar class="favorite">
                                                <span :class="[showcard?'favorite-count-cart':'favorite-count-heart']">
                                                <!-- <span class="favorite-count"> -->
                                                    {{order.items.length}}
                                                </span>
                                                <v-icon class="favorite" color="#fe5800" size="30" style="font-size:30" v-if="showcard==1">mdi-cart</v-icon>
                                                <v-icon class="favorite" color="#fe5800" size="30" style="font-size:30" v-else-if="showcard==0">mdi-heart</v-icon>
                                            </v-avatar>
                                            <!-- {{$t('zz_order')}} -->
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <!--<div v-if="business.coursesmaster[index].price>0 || business.coursesmaster[index].showon==1 || (business.coursesmaster[index].description!='null' && business.coursesmaster[index].description!=null )"></div>-->


<!-- ######################  COURSE TOP BANNER SECTION  ###################### -->


                                    <v-row  v-if="business.coursesmaster[index].showon==1" class="food-course-top-banner" tile>
                                        <v-col col="12">
                                            <v-row v-if="business.coursesmaster[index].price!='0.00' && business.coursesmaster[index].price!='' &&  business.coursesmaster[index].price!=null &&  business.coursesmaster[index].price!='null'">
                                                <v-col col="12" md="12" class="food-course-top-banner-price">
                                                    <!-- <span v-html="business.coursesmaster[index].price"></span> -->
                                                    <span v-html="business.coursesmaster[index].price"></span>

                                                </v-col>
                                            </v-row>
                                            <v-row v-if="business.coursesmaster[index].pricetext!='' &&  business.coursesmaster[index].pricetext!=null &&  business.coursesmaster[index].pricetext!='null'">
                                                <v-col col="12" md="12" class="food-course-top-banner-price-text">
                                                    <!-- <span v-html="business.coursesmaster[index].pricetext"></span> -->
                                                    <span v-html="userlangcode==''?business.coursesmaster[index].pricetext:business.coursesmaster[index].languagetranslations[userlangcode].subtitle"></span>
                                                    <!-- <span v-html="business.coursesmaster[index].languagetranslations[userlangcode].subtitle"></span> -->

                                                </v-col>
                                            </v-row>
                                            <v-row v-if="business.coursesmaster[index].showon==1 ">
                                                <v-col col="12" md="12" class="food-course-top-banner-description">
                                                    <span v-html="userlangcode==''?business.coursesmaster[index].description:business.coursesmaster[index].languagetranslations[userlangcode].description"></span>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-divider class="pb-2 ma-0" v-if="business.coursesmaster[index].showon==1"></v-divider>

<!-- ==============================================================  -->
<!-- COURSE HEADING BANNER  POP UP MENU COGS  -->
<!-- ==============================================================  -->
                                    <v-row style="top:0px; right:0px; position:absolute; z-index=20" class="pl-0 pr-0" justify="space-between" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                        <v-col class="pa-0 text-right">
                                            <template>
                                                <v-menu @click.native.stop transition="scale-transition">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn @click.stop float-right color="#FE5800" icon v-bind="attrs" v-on="on" v-if="business.coursesmaster[index].showon==1">
                                                            <v-icon style="top:50px; right:28px; position:absolute; z-index=11" class="compact-cogs-75">fa fa-cogs</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-row no-gutters justify="space-between">
                                                    <v-icon color="red" icon dark class="text-right close-menu-right pr-2 pt-2">mdi-close-circle</v-icon>
                                                    </v-row>
                                                    <v-row no-gutters class="px-4 quick-edit-card">
                                                        <span style="color:#FE5800" class="mt-10 course-text-heading">
                                                            {{index }}
                                                        </span>
                                                        <!-- <span class="mt-4 pl-4 course-text-heading">{{$t('zz_course_heading__text')}} <b>{{ index }}</b></span> -->
                                                    </v-row>
                                                    <v-row no-gutters justify="space-between" align-items="center" class="pt-4 quick-edit-card">
                                                        <v-cols no-gutters cols="6" class="">
                                                            <div class="" v-if="item.showonmenu==1">
                                                                <v-switch class="pr-0 compact-form bbrdt" no-gutters style="font-size:12px !important;" color="success" :input-value="shw"  @click="updateshowitem(item.id,item.course_id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                            </div>
                                                            <div class="d-flex" v-else>
                                                                <v-switch class="pr-0 compact-form" no-gutters style="font-size:12px !important;" color="" :input-value="nshw"  @click="updateshowitem(item.id,item.course_id,1)" :id="'showonitem-'+item.id"></v-switch>
                                                            </div>
                                                        </v-cols>
                                                    </v-row>
                                                    <v-row class="pt-4 quick-edit-card">
                                                        <v-cols no-gutters  cols="6" class="pl-2">
                                                            <v-btn icon @click="editFoodItem(item.id)" color="#FE5800 " fab small dark>
                                                                <v-icon>mdi-square-edit-outline</v-icon>
                                                            </v-btn>
                                                        </v-cols>
                                                    </v-row>
                                                    <v-divider></v-divider>
<!-- Displaying the Course Banner Text On Pop Up -->
                                                    <!-- <v-col col="12" color="primary" class="heading-pop-up" >
                                                        <v-row v-if="business.coursesmaster[index].price!='0.00' && business.coursesmaster[index].price!='' &&  business.coursesmaster[index].price!=null &&  business.coursesmaster[index].price!='null'">
                                                            <v-col col="12" md="12" class="food-course-top-banner-price">
                                                                <span v-html="business.coursesmaster[index].price"></span>
                                                                <span :v-html="userlangcode==''?business.coursesmaster[index].price:business.coursesmaster[index].languagetranslations[userlangcode].title"></span>

                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="business.coursesmaster[index].pricetext!='' &&  business.coursesmaster[index].pricetext!=null &&  business.coursesmaster[index].pricetext!='null'">
                                                            <v-col col="12" md="12" class="food-course-top-banner-price-text">
                                                                <span :v-html="userlangcode==''?business.coursesmaster[index].pricetext:business.coursesmaster[index].languagetranslations[userlangcode].subtitle"></span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="business.coursesmaster[index].showon==1 ">
                                                            <v-col col="12" md="12" class="food-course-top-banner-description">
                                                                <span :v-html="userlangcode==''?business.coursesmaster[index].description:business.coursesmaster[index].languagetranslations[userlangcode].description"></span>
                                                            </v-col>
                                                        </v-row>

                                                    </v-col> -->
                                                </v-menu>
                                            </template>
                                        </v-col>
                                    </v-row>



<!-- #################### Switching form List to Grid View ####################-->

                                <v-row  v-if="foodview=='grid'" :id="'foodgrid-'+item[0].course_id"
                                        class="" :column-width="'#colwidth-'+item[0].course_id" v-masonry="'foodgrid-'+item[0].course_id" transition-duration=".75s" item-selector=".grid-item">
                                    <div class="col-6 grid-item pa-0" :id="'colwidth-'+item[0].course_id">

                                    </div>

                                    <div :class="[food.foodstatus=='From Chef' || food.sepretor? ' col-12':' col-6', food.sepretor? '':'']" v-for="(food,ind) in item" :key="'itm-'+ind"
                                            class="pl-1 pr-1 pt-1 pb-1 grid-item"
                                            v-show="!food.hasallergen && food.hasmeat && food.hasdiet && food.haspoultry">

<!-- #################### FOOD GRID VIEW CARD SETTINGS ####################-->

                                    <!-- <v-card cols="12" md="12"  tile class="mx-auto cardborder-grid" max-width="100%" @click.prevent="fooditemdetails(food.id,food.course_id,'food')"> -->
                                        <!-- <v-card  style="postion:static" elevation="24" cols="12" md="12"  tile class="card-shape-grid" max-width="100%" @click.prevent="fooditemdetails(food.id,food.course_id,'food',food.sepretor)" :class="[food.hasimage?'':'noimagecardgrid',food.sepretor? 'section-heading-grid':'' ]"> -->
<!-- Image Zoom Animation -->
                                        <a @click.stop="fooditemdetails(food.id,food.course_id,'food',food.sepretor)" >
                                        <v-card :style="{'border-color': business.themecolor}"
                                        elevation="24" class="ma-1 pa-0 cardborder-listView" :class="[food.hasimage?'':'noimagecard', food.sepretor? 'section-heading primary':'', food.foodstatus=='Feature'? 'strokedcard':'' ]" tile>

                                            <div v-if="food.fimage=='https://api.juzzap.com/storage/images/blank.jpg'">
                                            </div>
                                            <div v-else>
                                                <v-img v-if="!food.sepretor"
                                                    :src="food.fimage"
                                                    class="image-shape-grid"
                                                    :class="food.foodstatus=='From Chef' ? 'imagezoomfast': (food.foodstatus=='Feature'? 'imagezoomslow':'')"
                                                    :height="(food.foodstatus=='From Chef'?150:(food.foodstatus=='Feature'?330:110))+'px'"
                                                    >

                                                </v-img>
                                            </div>
                                            <div class="">
                                                    <v-img :src="cheficonGrid" v-if="food.foodstatus=='From Chef'" class="cheficonFoodGrid"/>
                                            </div>
<!-- NEW GRID LAYOUT    GRID VIEW       -->
                                            <div style="position: relative" class="ma-0 pa-0">
<!-- QUICK EDITE COGS       -->
                                                <v-row class="pa-0 ma-0" style="align-items: end; float: right; top:-3px; right:2px; position: absolute; z-index=7" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                    <v-menu class="" @click.native.stop  transition="fab-transition">
                                                        <template v-slot:activator="{ on, attrs }"
                                                        top
                                                        left
                                                        transition="scale-transition"
                                                        >
                                                            <v-btn @click.stop color="#FE5800" icon v-bind="attrs" v-on="on">
                                                                <v-icon  class="compact-cogs-75" :class="[food.sepretor?'invert-text-colour ':'']">fa fa-cogs</v-icon>
                                                                <!-- <v-icon class="compact-cogs-75">fa fa-cogs</v-icon> -->
                                                            </v-btn>
                                                        </template>
                                                        <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0pt-2 pl-2" :class="[food.sepretor?'invert-text-colour ':'']">
                                                            mdi-close-circle
                                                        </v-icon>
                                                        <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1" :class="[food.sepretor?'primary ':'']">
                                                            <v-list-item>
                                                                <span style="color:#FE5800" class="mt-6 course-text-heading" :class="[food.sepretor?'invert-text-colour ':'']">

                                                                    {{userlangcode==''?food.title:food.langtransaltions[userlangcode].title}}
                                                                </span>
                                                            </v-list-item>
                                                            <div class="mt-0 pl-0 pr-0 d-flex" v-if="food.showonmenu==1">
                                                                <v-switch no-gutters style="font-size:12px !important;" color="success" :input-value="shw"  @click.stop="updateshowitem(food.id,food.course_id,0)" :id="'showonitem-'+item.id">
                                                                </v-switch>
                                                                <!-- {{food.id}} -->
                                                            </div>
                                                            <div class="d-flex" v-else>
                                                                <v-switch no-gutters style="font-size:12px !important;"  color="" :input-value="nshw"  @click.stop="updateshowitem(food.id,food.course_id,1)" :id="'showonitem-'+item.id">
                                                                </v-switch>
                                                                <!-- {{food.id}} -->
                                                            </div>
                                                            <v-list-item v-if="food.sepretor==0">
                                                                <v-btn icon @click.prevent="fooditemimage(food.id,food.course_id,food.showonmenu)" color="#FE5800" fab x-small dark class="mt-2 mb-2">
                                                                    <v-icon>mdi-camera-plus-outline</v-icon>
                                                                </v-btn>
                                                            </v-list-item>
                                                            <v-list-item v-if="food.sepretor==0">
                                                                <v-btn icon @click.prevent="foodstatusupdate(food.id,'From Chef')" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                    <v-icon>mdi-chef-hat</v-icon>
                                                                </v-btn>
                                                            </v-list-item>
                                                            <v-list-item v-if="food.sepretor==0">
                                                                <v-btn icon @click.prevent="foodstatusupdate(food.id,'Feature')" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                    <v-icon>mdi-star-shooting-outline</v-icon>
                                                                </v-btn>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-btn icon @click="edititem(food.id)" color="#FE5800 " fab x-small dark class="mt-2 mb-2" :class="[food.sepretor?'invert-text-colour ':'']">
                                                                    <v-icon>mdi-square-edit-outline</v-icon>
                                                                </v-btn>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-btn justify="center" icon @click="deleteItemCourse(food.id)" color="#FE5800 " fab x-small dark class="">
                                                                    <v-icon>mdi-trash-can-outline</v-icon>
                                                                </v-btn>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </v-row>
<!-- QUICK EDITE COGS    ++++END+++   -->
                                                <v-col cols="12" md="12" class="pa-0 ma-0 pl-2 pr-2">
                                                    <v-row no-gutters dense class="pr-3">
                                                        <span v-if="food.title" :class="[food.sepretor? 'food-separator-title-gridView':' food-title-gridView' ]">
<!-- TITLE  GRID VIEW-->

                                                            {{userlangcode==''?food.title:food.langtransaltions[userlangcode].title}}

                                                        </span>
                                                    </v-row>
                                                    <v-row no-gutters dense class="food-subtitle-gridView" v-if="food.subtitle!='null' || food.subtitle!=null || food.subtitle!=''" :class="[food.sepretor? 'food-separator-subtitle-gridView':'' ]">



                                                        {{userlangcode==''?food.subtitle:food.langtransaltions[userlangcode].subtitle}}

                                                    </v-row>
                                                    <v-row no-gutters dense  v-if="food.chillispice>0">
                                                        <span v-if="!food.sepretor" v-for="n in 5" :key="n" class="">
                                                            <img :src="n<=food.chillispice?chilli:chillio" width="10">
                                                        </span>
                                                    </v-row>
                                                    <v-row no-gutters dense  v-if="food.fdesc!='NULL' || food.fdesc!=NULL || food.fdesc!='null' || food.fdesc!=null || !food.sepretor">
                                                        <v-col v-if="food.fdesc || !food.sepretor"  class="food-description-grid" >
<!-- FOOD GRID View DESCRIPTION  -->                             <p v-if="!food.sepretor" v-html="userlangcode==''?food.fdesc:food.langtransaltions[userlangcode].description"></p>
                                                        </v-col>
                                                    </v-row>
                                                    <div v-if="food.itemsize.length>0 && !food.sepretor" class="mt-4 mb-2">


<!-- FOOD GRID View Pricing Row Starts Here   -->

                                                    <v-col cols="12" md="12" v-for="(size, indexsize) in food.itemsize" :key="'itsz-'+indexsize" class="food-price-row-grid">
                                                        <v-row class="align-end">
                                                        <v-col cols="5" md="5" class="food-item-portion-text-grid">
<!-- Portion Size Text  -->                                 <span>
                                                                {{size.size}}
                                                            </span>
                                                        </v-col>
                                                        <v-col cols="5" md="5" class="pb-0 pt-0 pl-0 text-right">
                                                            <span class="" v-if="size.special>0 && size.price>0.01">
    <!-- (Original) Was Price  -->                              <span class="was-price-grid strikethrough" >
                                                                    {{parseFloat(size.price).toFixed(2)}}
                                                                </span>
<!-- Special Offer Price New Price   -->                        <span class="pl-1 special-offer-price-grid">
                                                                    {{parseFloat(size.special).toFixed(2)}}
                                                                </span>
                                                            </span>
                                                            <span v-else-if="size.price>0.01" class="food-item-price-text-grid">
                                                                {{parseFloat(size.price).toFixed(2)}}
                                                            </span>
                                                        </v-col>
<!-- Add To Fav Icons Food Grid view   -->
                                                        <v-col cols="2" md="2" class="pb-0 pt-0 pl-0 pr-5 custom-size">
                                                            <v-row>
                                                                <v-col cols="12" class="price-row-favorite-icon" v-if="checkitemfavoritefood(food.id,food.course_id,size.size)">
                                                                    <v-icon v-if="showcard==1"  size="16" :color="food.foodstatus=='Feature'? '#FE5800':'#FE5800'"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-cart</v-icon>
                                                                    <v-icon v-else-if="showcard==0"  size="16" :color="food.foodstatus=='Feature'? '#FE5800':'#FE5800'"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-heart</v-icon>
                                                                </v-col>
                                                                <v-col cols="12" class="price-row-favorite-icon" v-else>
                                                                    <v-icon v-if="showcard==1"  size="10"  :color="food.foodstatus=='Feature'? '#FE5800':'#FE5800'"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-cart-outline</v-icon>
                                                                    <v-icon v-if="showcard==0"  size="10" :color="food.foodstatus=='Feature'? '#FE5800':'#FE5800'"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-heart-outline</v-icon>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </div>
                                            </v-col>
                                        </div>
                                    <v-col no-gutters cols="12" md="12" class="pa-0 ma-0 card-text-container-gridView" :class="[food.sepretor? 'card-separator-container':'' ]">
                                    </v-col>
                                </v-card>
                                </a>

                            </div>
                            <div style="clear:both;"></div>
                            </v-row>

<!-- #################### FOOD MENU GRID VIEW  ENDS HERE ####################-->



<!-- #################### FOOD LIST VIEW STARTS HERE #################### -->

                                <col clos="12" md="12" no-gutters class="ma-0 pa-0">
                                    <div v-if="foodview=='list'" :style="{'border-color': business.themecolor}">
                                        <div cols="12" v-for="(food,ind) in item" :key="ind" class="ma-0 pa-0 mb-2" v-show="!food.hasallergen && food.hasmeat && food.hasdiet && food.haspoultry">

                                            <a @click.stop="fooditemdetails(food.id,food.course_id,'food',food.sepretor)" >

                                                <v-card :style="{'border-color': business.themecolor}"
                                                elevation="24" class="max-400 ma-0 pa-0 mb-5 cardborder-listView" :class="[food.hasimage?'':'noimagecard',food.sepretor? 'section-heading primary':'', food.foodstatus=='Feature'? 'strokedcard':'' ]" tile>
    <!-- Image Zoom Animation -->
                                                <v-row no-gutters class="ma-0 pa-0 section-spread">
                                                        <v-col cols="4" class="ma-0 pl-0 pt-0 pb-0" v-if="food.hasimage">
                                                            <container jusitfy:start>
                                                                <v-img height="100%" v-if="!food.sepretor"
                                                                class="food-shape-photo-listView"
                                                                :class="food.foodstatus=='From Chef' ? 'imagezoomfast': (food.foodstatus=='Feature'? 'imagezoomslow':'')"
                                                                :src="food.fimage"
                                                                >
                                                            </v-img>
                                                            <!-- </v-avatar> -->
                                                            <!-- </div> -->
                                                            </container>
                                                            <div no-gutters class="ma-0 pl-0 pt-0 pb-0">
                                                            <img :src="cheficonList" v-if="food.foodstatus=='From Chef'" :class="$store.getters.user && $user.userType=='business' && business.id==$user.business.id? 'cheficonFoodList-loggedin':'cheficonFoodList'"/>
                                                            </div>
                                                        </v-col>

                                                        <v-col :cols="food.hasimage?8:12"  class="parent card-text-container" :class="[food.sepretor? 'card-separator-container':'' ]">


<!-- ==============================================================  -->
<!-- LIST VIEW POP UP MENU COGS  -->
<!-- ==============================================================  -->
                                                            <v-row style="top:0px; right:0px; position:absolute; z-index=7" class="pl-0 pr-0" justify="space-between" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                                <v-col class="pa-0 text-right">
                                                                    <template>
                                                                        <v-menu @click.native.stop transition="fab-transition">
                                                                            <template v-slot:activator="{ on, attrs }"
                                                                            top
                                                                            right
                                                                            transition="scale-transition"
                                                                            v-model="closeOnContentClick">
                                                                                <v-btn @click.stop float-right color="#FE5800" icon v-bind="attrs" v-on="on">
                                                        <!-- LIST VIEW -->
                                                                                    <v-icon style="top:-14px; right:26px; position:absolute; z-index=7" class="compact-cogs-75" :class="[food.sepretor?'invert-text-colour ':'']">fa fa-cogs</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <v-icon color="red" icon dark class="text-right close-menu-right pa-0 ma-0 pt-2 pr-3" :class="[food.sepretor?'invert-text-colour ':'']">mdi-close-circle</v-icon>
                                                                            <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1" :class="[food.sepretor?'primary ':'']">
                                                                               <v-list-item v-if="food.sepretor==1" class="text-left" >
                                                                                    <span style="color:#FE5800" class="mt-4 course-text-heading"><p :class="[food.sepretor?'invert-text-colour ':'']">{{$t('zz_section')}}</p></span>
                                                                               </v-list-item>
                                                                               <v-list-item v-else="food.sepretor==1">
                                                                                    <span style="color:#FE5800" class="mt-4 course-text-heading" :class="[food.sepretor?'invert-text-colour ':'']">
                                                                                        {{userlangcode==''?food.title:food.langtransaltions[userlangcode].title}}
                                                                                    </span>
                                                                               </v-list-item>
<!-- TOGGLE SWITCH SHOW OR HIDE ITEM  -->                                      <v-list-item>
                                                                                    <div class="mt-0 pl-0 pr-0 d-flex" v-if="food.showonmenu==1">
                                                                                        <v-switch class="pl-1 compact-form" inset  no-gutters style="font-size:12px !important;" color="success" :input-value="shw"  @click="updateshowitem(food.id,food.course_id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                                    </div >
                                                                                <div class="d-flex" v-else>
                                                                                    <v-switch class="pl-1 compact-form" inset   no-gutters style="font-size:12px !important;" color="" :input-value="nshw"  @click="updateshowitem(food.id,food.course_id,1)" :id="'showonitem-'+item.id"></v-switch>
                                                                                </div>

                                                                                </v-list-item>
                                                                                <v-list-item v-if="food.sepretor==0">
                                                                                    <v-btn icon @click.prevent="fooditemimage(food.id,food.course_id,food.showonmenu)" color="#FE5800" fab x-small dark class="mt-2 mb-2">
                                                                                        <v-icon>mdi-camera-plus-outline</v-icon>
                                                                                    </v-btn>
                                                                                </v-list-item>
                                                                                <v-list-item v-if="food.sepretor==0">
                                                                                    <v-btn icon @click.prevent="foodstatusupdate(food.id,'From Chef')" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                                        <v-icon>mdi-chef-hat</v-icon>
                                                                                    </v-btn>
                                                                                </v-list-item>
                                                                                <v-list-item v-if="food.sepretor==0">
                                                                                    <v-btn icon @click.prevent="foodstatusupdate(food.id,'Feature')" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                                        <v-icon>mdi-star-shooting-outline</v-icon>
                                                                                    </v-btn>
                                                                                </v-list-item>
                                                                                <v-list-item>
                                                                                    <v-btn icon @click="edititem(food.id)" color="#FE5800 " fab x-small dark class="mt-2 mb-2" :class="[food.sepretor?'invert-text-colour ':'']">
                                                                                        <v-icon>mdi-square-edit-outline</v-icon>
                                                                                    </v-btn>
                                                                                </v-list-item>
                                                                                <v-list-item>
                                                                                    <v-btn justify="center" icon @click="deleteItemCourse(food.id)" color="#FE5800 " fab x-small dark class="">
                                                                                        <v-icon>mdi-trash-can-outline</v-icon>
                                                                                    </v-btn>
                                                                                </v-list-item>
                                                                            </v-list>
                                                                        </v-menu>
                                                                    </template>
                                                                </v-col>
                                                            </v-row>
<!-- ==============================================================  -->
<!-- LIST VIEW POP UP MENU COGS END -->
<!-- ==============================================================  -->

                                                            <div class="">
                                                                <div>
                                                                    <div style="postion:static" class="card-content" >
                                                                        <v-row no-gutters dense>
                                                                            <v-col cols="12" class="">
                                                                                <v-row no-gutters dense class="food-title-listView-c">
                                                                                    <v-col v-if="food.title" cols="12" md="12"  :class="[food.sepretor? 'separator-title':'' ]">

<!-- FOOD TITLE List View  -->
                                                                                         {{userlangcode==''?food.title:food.langtransaltions[userlangcode].title}}

                                                                                    </v-col>
                                                                                </v-row>
                                                                                <v-row no-gutters dense class="food-subtitle-listView-c" v-if="food.subtitle!='null' || food.subtitle!=null">
                                                                                    <v-col v-if="food.subtitle"  cols="12" md="12" :class="[food.sepretor? 'separator-subtitle':'' ]">

<!-- FOOD SUBTITLE  List View-->

                                                                                        {{userlangcode==''?food.subtitle:food.langtransaltions[userlangcode].subtitle}}<br>

                                                                                        <div v-if="food.chillispice >0">
                                                                                        <span v-for="n in 5" :key="n" class="lh-12 pl-auto pr-auto ">
                                                                                        <img :src="n<=food.chillispice?chilli:chillio" width="10">
                                                                                        </span>
                                                                                    </div>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-col>
                                                                        </v-row>
                                                                        <v-row no-gutters dense class="" v-if="food.fdesc!='NULL' || food.fdesc!=NULL || food.fdesc!='null' || food.fdesc!=null || food.sepretor==!1">
                                                                            <v-col v-if="food.sepretor==0" cols="12" class="food-description-listView-c mb-4">
<!-- FOOD DESCRIPTION List View  -->
                                                                              <p class="" v-if="food.fdesc" v-html="userlangcode==''?food.fdesc:food.langtransaltions[userlangcode].description"></p>
                                                                            </v-col>

                                                                        </v-row>
                                                                    </div>

                                                                    <!-- <v-row cols="12" class="ma-0 pa-0" :class="food.itemsize.length>1" :cols="food.hasimage?8:12"> -->

<!-- FOOD List View Pricing Row Starts Here   -->
                                                                    <div v-if="food.sepretor==0" class="mt-2 pt-4 pb-4">
                                                                            <v-col :cols="food.hasimage?8:12"  class="pt-0 pb-0 pl-5 ma-0 food-price-section">

                                                                            <v-col cols="12" v-for="(size, indexsize) in food.itemsize" :key="'psz-'+indexsize" class="ma-0 pa-0 pr-3">
                                                                                <v-row class="align-end food-price-row-listView ma-0">
<!-- Food List View Portion Size Text  -->                                          <v-col cols="5" md="5" class="food-portion-text-listView ma-0">
                                                                                    <span class="pl-1">
                                                                                        {{size.size}}
                                                                                    </span>
                                                                                    </v-col>

                                                                                    <v-col cols="6" md="6" class="ma-0 pa-0 text-right-listView">
                                                                                        <span class="food-price-listView" v-if="size.special>0 && size.price>0.01">
                <!-- Food list View Original / Was Price  -->                               <span class="was-price-listView strikethrough text-right mr-1" >
                                                                                                {{parseFloat(size.price).toFixed(2)}}
                                                                                            </span>
                <!-- Food List View New / Special Offer Price   -->
                                                                                            <span class="ma-0 pa-0 food-now-price-listView text-right">
                                                                                                {{parseFloat(size.special).toFixed(2)}}
                                                                                            </span>

                                                                                            <!-- THE CODE BELOW SHOWS COLOUR BACKGROUND OF SPECIAL OFFER PRICE
                                                                                            <span :style="[ business.themecolor!='' ?{'background': business.themecolor}:{'background': '#FE5800'} ]"
                                                                                            class="mr-2 special-offer-price">{{parseFloat(size.special).toFixed(2)}} </span>  -->
                                                                                        </span>
                                                                                        <span v-else-if="size.price>0.01" class="food-now-price-row-listView">
                <!-- Regular RRP Price    -->                                              {{parseFloat(size.price).toFixed(2)}}
                                                                                        </span>
                                                                                        <!-- <span v-else style="font-size:12px;line-height:1;" >{{parseFloat(size.price).toFixed(2)}} </span> -->
                                                                                    </v-col>

                                                                                    <v-col cols="1" md="1" class="ma-0 pa-0 custom-size">
                                                                                        <v-row>
                                                                                            <v-col cols="12" class="price-row-favorite-icon" v-if="checkitemfavoritefood(food.id,food.course_id,size.size)">
                                                                                                <v-icon v-if="showcard==1"  size="16" color="#fe5800"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-cart</v-icon>
                                                                                                <v-icon v-else-if="showcard==0"  size="16" color="#fe5800"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-heart</v-icon>
                                                                                            </v-col>
                                                                                            <v-col cols="12" class="price-row-favorite-icon" v-else>
                                                                                                <v-icon v-if="showcard==1"  size="10" color="#9494940"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-cart-outline</v-icon>
                                                                                                <v-icon v-if="showcard==0"  size="10" color="#949494"  @click.stop="togglefav(food.id,food.course_id,index,size.price,food.fimage,food.title,food.subtitle,size.size+'|'+size.price)">mdi-heart-outline</v-icon>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-col>
                                                                                </v-row>

                                                                            </v-col>
                                                                        </v-col>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>

                                            </a>
                                        </div>
                                    </div>
                            </v-tab-item>
                        </v-tabs-items>
<!-- ################ Food List View END ###################### -->


<!-- Course Tabs -->


                </div>



<!--################ Allergen Filters Panel ################   -->
                <div v-if="filter" style="padding-left:15px;padding-right:15px;">
                    <!-- <div style="padding-left:15px;padding-right:15px;"> -->
                    <!-- meat div -->
                    <v-container>
                        <v-row>
                            <v-col cols="12" style="color:#fe5800;">
                                {{$t('zz_diet')}}
                            </v-col>

                            <v-col cols="12" class="text-right">
                                <v-btn text tile
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                                @click="setRemovedDiets">
                                    <span v-if="dietSelectAll">{{$t('zz_select_all')}}</span>
                                    <span v-else>{{$t('zz_clear_all')}}</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>

                            <v-col
                            :style="[ business.themecolor!=''?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                             style="font-size:12px;color:#FE5800;padding:2px;" cols="4" v-for="(diet, index) in business.diets" :key="'a'+index" class="text-center">

                            <v-btn block height="70" tile  @click="toggleDiet(diet.id)"

                            :outlined="removedDiets.indexOf(diet.id)==-1?false:true">
                                <div style="font-size:9px;">
                                    <span >
                                    <img style="display:block;margin:0 auto;padding:10px;" :src="diet.img"  width="45"/></span>


                                    <span class="text-wrap" v-html="diet.name"></span>

                                </div>
                            </v-btn>

                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" style="font-size:14px;text-align:center;">
                                Was this feature is useful for you ?

                            </v-col>
                            <v-col cols="12" class="text-center pa-0">
                                <v-rating
                                color= "#FE5800"

                                v-model="dietrating"></v-rating>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="12" class="">
                                <!-- <v-btn color="primary" @click="filter=0">Close Filters</v-btn> -->
                                Please use the filters below to view only what you like, we will hide the rest!
                            </v-col>
                        </v-row>
                    </v-container>


                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"

                                @click="filter=0">{{$t('zz_close_filters')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>



                <div v-if="filterAllergens" style="padding-left:15px;padding-right:15px;">

                    <v-row>

                        <!-- <v-col cols="12" style="font-weight:bold;color:black;"> -->
                        <v-col v-col cols="12" class="allergen-filter-title">
                                {{$t('zz_allergens')}}
                        </v-col>

                        <v-col v-col cols="12" class="allegen-filter-text">

                            <span v-html="$t('zz_allergens_text')"> </span>
                        </v-col>
                    </v-row>
                    <v-col cols="12" class="pb-5 ma-0">
                            <v-btn block
                            :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                            @click="saveAllergens()" outlined>{{$t('zz_save')}}</v-btn>
                        </v-col>
                    <v-row>
                        <v-col :style="[ business.themecolor!=''?{'color': business.themecolor}:{'color': '#00fe2c'} ]" style="font-size:12px; color:#00fe2c; padding:2px;" cols="4" v-for="(allergen, index) in business.allergen" :key="'a'+index" class="text-center">
                        <v-btn block height="90" tile  @click="addAllergens(allergen.id,allergen.name)"
                        :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                        :outlined="selectedAllergens.indexOf(allergen.id)!=-1?false:true">
                            <div style="font-size:9px;">
                                <span ><img style="display:block;margin:0 auto;padding:10px;" :src="allergen.image"  width="45"/></span>
                                <span class="text-wrap" v-html="allergen.name"></span>
                            </div>
                        </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" >
                            <v-btn block
                            :color= "business.themecolor!=''?business.themecolor:'#FE5800'"
                            @click="saveAllergens()" outlined>{{$t('zz_save')}}</v-btn>
                        </v-col>
                        <!-- <v-col cols="6" >
                            <v-btn color="primary" @click="noAllergens()" outlined>No Allergens</v-btn>
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col cols="12" style="font-size:14px;text-align:center;">
                            {{$t('zz_like_this_feature')}}

                        </v-col>
                        <v-col cols="12" class="text-center pa-0">
                            <v-rating
                            color= "#FE5800"
                            v-model="allergensrating"></v-rating>
                        </v-col>

                    </v-row>

                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"

                                @click="filterAllergens=0">{{$t('zz_close_filters')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>

                <div v-if="filtera">
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="">
                                <!-- <v-btn color="primary" @click="filter=0">Close Filters</v-btn> -->
                                Please use the filters below to view only what you like, we will hide the rest!
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                :color= "business.themecolor!=''?business.themecolor:'#FE5800'"

                                @click="filtera=0">{{$t('zz_close_filters')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
                <!-- <v-divider></v-divider> -->
                        <p class="powered-by-juzzap">powered by juZZap</p>
                <!-- Filters     -->
            </v-card-text>



        </v-card>
<!-- </v-card> -->
<!-- EDIT/ADD IMAGE OVERLAY  -->
        <v-dialog v-model="itemimagedialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card tile class="" elevation="3" color="#fff"   >
                <v-card-text class="pa-0 carddetail" elevation="3" color="#fff">
                    <v-form v-model="valid" enctype="multipart/form-data" id="editfooditem">
                    <container >

                        <!-- <v-row>
                            <v-col cols="9" md="9" class="pl-7">
                              {{$t('zz_show_on_menu')}}
                            </v-col>
                            <v-col cols="3" md="3" class="pb-0">
                                <div v-if="fooditemshowonmenu==1 ">
                                    <v-switch  color="success" :input-value="shw" @click="updateshowitem(itemupdateid,itemupdatecourseid,0)"   :id="'showonitem-'+itemupdateid"></v-switch>
                                </div>
                                <div v-else>
                                    <v-switch  color="" :input-value="nshw" @click="updateshowitem(itemupdateid,itemupdatecourseid,1)"  :id="'showonitem-'+itemupdateid"></v-switch>

                                </div>
                            </v-col>
                        </v-row> -->

                        <v-row>
                            <v-col cols="12" md="12" class="pl-7">
                                {{$t('zz_change_image')}}

                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" sm="12">

                                <v-row v-if="mainimguploading">
                                    <v-col cols="12" class="text-center">
                                        <v-progress-circular
                                        indeterminate
                                        color="primary"
                                        ></v-progress-circular>
                                    </v-col>
                                </v-row>
                                <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange"/>
                                <!-- <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/> -->
                                <v-row>
                                    <!-- <v-col col="12" md="12" sm="12" v-if="food.fimage!='https://api.juzzap.com/'">
                                        <img
                                        style="max-width:100%"
                                        :src="food.fimage"
                                        class="grey lighten-2"
                                        max-height="300"
                                        v-if="image!=null"
                                        />
                                    </v-col> -->
                                </v-row>
                                <v-row>
                                        <v-col cols="12" md="12" sm="12" class="text-center mb-5 mt-3" >
                                          <!-- <v-btn color="primary" @click="$refs.file.click()">
                                            <input
                                              type="file"
                                              ref="file"
                                              @change="uploadImage($event)"
                                              accept="image/*"
                                              class="d-none"
                                              id="itemimage"
                                            /> Upload Image
                                          </v-btn> -->
                                          <!-- <v-img class="backimg"  :src="addphoto" @click="$refs.file.click()" style="max-height:100px;background-size: contain;"> -->
                                            <v-img @click="$refs.file.click()">
                                            <input
                                              type="file"
                                              ref="file"
                                              @change="uploadImage($event)"
                                              accept="image/*"
                                              class=""
                                              id="itemimage"
                                            />
                                          </v-img>
                                        </v-col>

                                        <v-col cols="12" md="12" sm="12" class="text-center mb-9">
                                            <v-btn color="primary" block large @click.stop="updateimage">{{$t('zz_save_drink_menu_changes')}}</v-btn>

                                        </v-col>

                                      </v-row>

                            </v-col>

                        </v-row>
                    </container>
                    </v-form>
                </v-card-text>
            </v-card>
            <v-footer
                absolute
                class="font-weight-medium "
                color="transparent">
                    <v-col
                        class="text-center"
                        cols="12"
                    >
                        <v-btn @click="backtomenuimage" fab small color="#fe5800" >
                            <v-icon class="white--text ">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
            </v-footer>
        </v-dialog>

        <v-dialog v-model="itemdialogolddesign" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

            <v-card tile class="carddetail" elevation="3" color="#fff"   v-show="fooditemid>0" >

                <v-card-text class=" pa-0 carddetail ">
                    <v-img height="241" :src="fooditem.fimage" aspect-ratio="1" class="carddetail">

                        <div class="white--text carddetail" :style="[ fooditem.foodstatus=='From Chef'?{'background-color': business.themecolor}:{'background-color': '#FE5800'} ]" style="position:absolute;bottom:0px;left:0px;text-align:center;width:190px;height:41px;line-height:41px" v-if="fooditem.foodstatus=='From Chef'"><v-icon color="#fff">mdi-chef-hat</v-icon> {{$t('zz_chefs_choice')}}</div>
                    </v-img>


                    <v-row>
                        <v-col cols="4" md="4" sm="4">
                            <v-row>
                                <v-col cols="6" v-for="(allergen, index) in fooditem.allergens" :key="'al-'+index" class="text-center pl-3 pr-3">
                                    <img :src="allergen.image"  width="32"/>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="4" md="4" sm="4">
                            <v-row>
                                <v-col cols="6" v-for="(meat, index) in fooditem.meats" :key="'m-'+index" class="text-center">
                                    <img :src="meat.image"  width="32"/>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="4" md="4" sm="4">
                            <v-row>
                            <v-col cols="12" class="pl-1 pr-1"><span v-for="n in 5" :key="n" class="chili-size">
                                 <img :src="n<=fooditem.chillispice?chilli:chillio" width="15">
                                <!-- <v-icon :color="n<=fooditem.chillispice?'red':''" >mdi-chili-mild</v-icon> -->
                            </span></v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row class="ma-0">

                        <v-col cols="9" md="9" sm="9" class=" pl-3 pr-3">
                            <div class="headline font-weight-bold" style="text-transform:uppercase;">{{fooditem.title}}</div>
                            <div class="subtitle-1 font-weight-light" style="line-height:1">{{fooditem.subtitle}}</div>
                            <div class="primary--text" v-if="fooditem.id!=0 "
                                :style="[ business.themecolor!=''?{'color': business.themecolor}:{'color': '#FE5800'} ]"
                                style="line-height:1;font-size:14px;font-weight:bold;" >
                                {{fooditem.courses[0].coursename}}
                            </div>
                        </v-col>

                        <v-col cols="3" class="pl-1 pb-0" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                            <v-icon size="12" @click.stop="edititem(fooditem.id)" class="compact-cogs-75">fa fa-cogs</v-icon>
                        </v-col>

                        <v-col cols="3" class="text-right pl-3 pr-3" v-else-if="fooditem.id!=0 && checkitemfavorite(fooditem.id,fooditem.courses[0].cid)">
                            <a @click="togglefav(fooditem.id,fooditem.courses[0].cid,fooditem.courses[0].coursename,fooditem.courses[0].price,fooditem.fimage,fooditem.title,fooditem.subtitle)">
                                <img :src="imgfavminus" width="46" />
                            </a>
                        </v-col>
                        <v-col cols="3" class="text-right pl-3 pr-3" v-else>
                            <a @click="togglefav(fooditem.id,fooditem.courses[0].cid,fooditem.courses[0].coursename,fooditem.courses[0].price,fooditem.fimage,fooditem.title,fooditem.subtitle)">
                                <img :src="imgfavplus" width="46" />
                            </a>
                        </v-col>


                    </v-row>
                    <v-row class="ma-0">
                        <!-- <v-col cols="12" class="pb-0">
                        <h2 class="title">Description</h2>
                        </v-col> -->
                        <v-col cols="12" class="pt-0 pl-3 pr-3" v-html="fooditem.description"></v-col>
                    </v-row>

                    <!-- <v-expansion-panels tile>

                        <v-expansion-panel>
                            <v-expansion-panel-header style="color:#fe5800;background:#FFB792"><strong >Good To Know</strong>   </v-expansion-panel-header>
                                <v-expansion-panel-content style="background:#FFB792">
                                    <p> For carefree browsing use the ‘Filters’ for things like allergens and diet choices such as vegan or chicken only... You will always find the ‘Filters’ icon in the top right corner by scrolling up to the top of the page </p>
                                </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels> -->

                    <!-- <v-row align="center" v-if="fooditem.chillispice>0" class="ma-0">
                        <v-col cols="12" class="pl-3 pr-3"><h2 class="title">Spicy</h2></v-col>
                        <v-col cols="12" class="mt-0 pt-0 pl-3 pr-3"><span v-for="n in 5" :key="n" class="pl-1 pr-1">
                            <v-icon :color="n<=fooditem.chillispice?'red':''" >mdi-chili-mild</v-icon>
                        </span></v-col>
                    </v-row> -->

                    <!-- <v-row v-if="fooditem.allergens.length>0" class="ma-0">
                        <v-col cols="12" class="pb-0 pl-3 pr-3">
                        <h2 class="title">Allergens</h2>
                        </v-col>
                        <v-col cols="3" v-for="(allergen, index) in fooditem.allergens" :key="'p'+index" class="text-center pl-3 pr-3">
                            <img :src="allergen.image"  width="32"/><br>{{allergen.name}}
                        </v-col>

                    </v-row>-->

                    <!-- <v-row v-if="fooditem.meats.length" class="ma-0">
                        <v-col cols="12" class="pb-0 pl-3 pr-3">
                        <h2 class="title">This Dish Contains</h2>
                        </v-col>
                        <v-col cols="3" v-for="(meat, index) in fooditem.meats" :key="'m'+index" class="text-center">
                            <img :src="meat.image"  width="32"/><br>{{meat.name}}
                        </v-col>

                    </v-row>  -->



                    <v-row v-if="fooditem.drinkitems.length" class="ma-0">
                        <v-col cols="12" class="pb-0 pl-3 pr-3">
                            <h2 class="title">Drink Pairing</h2>
                        </v-col>
                        <v-col cols="6" v-for="(drinkitem, index) in fooditem.drinkitems" :key="'d'+index" class="text-center">

                            <v-card
                            tile
                            class="mx-auto cardborder "
                            max-width="100%"
                            @click.prevent="drinkitemdetails(drinkitem.drinkid,drinkitem.typeid)"
                            >

                                <v-img
                                :src="drinkitem.image"
                                class="drinkimg"
                                height="250px"
                                max-width="100%"
                                style="position:relative"
                                >

                                </v-img>

                                <v-card-text>
                                    <v-row>
                                        <v-col cols="10" md="10" class="foodtitle pa-0 pb-3">
                                            {{drinkitem.name}}
                                        </v-col>
                                        <v-col cols="2" class="pl-1 pt-0 pb-0 favorite" v-if="checkitemfavorite(drinkitem.drinkid,drinkitem.typeid)">



                                            <v-icon  @click.stop="togglefavdrink(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,'drink')" size="16" color="#fe5800">mdi-heart-outline</v-icon>

                                        </v-col>
                                        <v-col class="pl-1 pb-0 pt-0" cols="2" v-else>



                                                <v-icon  @click.stop="togglefavdrink(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,'drink')" size="16" color="#fe5800">mdi-heart</v-icon>

                                        </v-col>
                                        <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'m'+index" class="text-center pb-0 pt-0">
                                            <v-row>
                                                <v-col cols="4" md="4" class="pa-0">
                                                    {{measure.mname}}
                                                </v-col>
                                                <v-col cols="4" md="4" class="pa-0">
                                                    <!--<i class="fa " :class="business.currency.icon" aria-hidden="true"></i>-->{{measure.price}}
                                                </v-col>
                                                <v-col cols="4" md="4" class="pa-0">
                                                    {{measure.qty}}{{measure.unit}}
                                                </v-col>
                                            </v-row>
                                            <!-- <div>{{measure.mname}} <span class="pl-1 pr-1">{{measure.price}}</span><span class="pl-1 pr-1">{{measure.qty}}{{measure.unit}}</span> </div> -->

                                        </v-col>

                                    </v-row>

                                </v-card-text>

                            </v-card>


                        </v-col>
                    </v-row>
                    <!-- <v-divider></v-divider> -->

                    <v-row class="d-none">
                        <v-col cols="12" class="pb-0">
                            <h2 class="title">Add to your shortlist...</h2>
                        </v-col>
                        <v-col cols="12" >
                            <v-row v-for="(course, index) in fooditem.courses" :key="'c'+index" align="center">
                                <v-col cols="4">{{course.coursename}}</v-col>
                                <v-col cols="5"><v-text-field @change="setitemtotal(course.courseid)" @keyup="setitemtotal(course.courseid)" @input="setitemtotal(course.courseid)" value="0" :name="'course['+course.courseid+']'" @click:append-outer="addqty(course.courseid)" :id="'course-'+course.courseid"
                                    @click:prepend="subtractqty(course.courseid)" min="0" type="number" :data-price="course.price" label="Qantity" prepend-icon="mdi-minus-circle-outline" append-outer-icon="mdi-plus-circle-outline" v-model="itemqty"></v-text-field></v-col>
                                <v-col cols="3"><span class="mr-1" :id="'cp-'+course.courseid">{{parseFloat(course.price).toFixed(2)}}</span> </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" >
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12" >
                            <v-row>
                                <v-col cols="6"><strong>Total</strong></v-col>

                                <v-col cols="6" class="text-right"><strong class="mr-1" id="tp-total">0.00</strong> </v-col>

                            </v-row>
                        </v-col>
                    </v-row>
                    <p class="mb-12 pb-12"></p>

                </v-card-text>

            </v-card>

            <v-footer
            absolute
            class="font-weight-medium "
            color="transparent">
                    <v-col
                        class="text-center"
                        cols="12"
                    >
                        <v-btn @click="backtomenu"

                        fab small color="#fe5800" >
                            <v-icon class="white--text ">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
            </v-footer>


        </v-dialog>

<!-- ######################## Food Detail Card Popup Dialog ##################### -->

        <v-dialog v-model="itemdialog" content-class="itemdetaildialog " scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card tile class="detail-card-food max-400" elevation="3" color="#fff"   v-show="fooditemid>0" >
                <v-card-text class="pa-0 detail-card-food pb-8">
                    <v-img min-width="100%"
                    :src="fooditem.fimage"
                    class="detail-card-food"
                    :class="fooditem.foodstatus=='From Chef' ? 'imagezoomfast': (fooditem.foodstatus=='Feature'? 'imagezoomslow':'')">
                        <div class="" :style="[ fooditem.foodstatus=='From Chef'?{'background-color'
                            :business.themecolor}:{'background-color': '#FE5800'} ]"
                            v-if="fooditem.foodstatus=='From Chef'">
                            <!-- <v-icon color="#fff">mdi-chef-hat</v-icon> -->
                            <!-- {{$t('zz_chefs_choice')}} -->
                            </div>
                    </v-img>
                    <v-img :src="cheficonGrid" v-if="fooditem.foodstatus=='From Chef'" class="cheficonFoodDetailCard2"/>

                    <!-- <img :src="editimageicon" class="pulse" width="28" v-if=" $store.getters.user && $user.userType=='business' && business.id==$user.business.id"
                    style="top:5px;right:10px;position:absolute;z-index=99999" @click.prevent="fooditemimage(fooditem.id,fooditem.courses[0].courseid,fooditem.showonmenu)"/> -->

                    <!-- <v-row class="ma-0" >
                    </v-row> -->

                    <!-- <v-divider></v-divider> -->

<!-- FOOD & DRINK PAIRING DETAIL FOOD CARD PAIRED from Food Detail Card Foodanddrink-->

                    <v-row class="ma-0 pt-0  pl-0 pr-0 ">
                        <v-col cols="12" md="12" sm="12" class="drink-detail-card-section-headings text-center" v-if="fooditem.drinkitems.length">
                        <!-- <v-col cols="12" md="12" sm="12" class="detail-card-food-drink-pairing-text" v-if="fooditem.drinkitems.length"> -->
                            <p>
                                {{$t('zz_drink_pairing_text-food_detail_card')}}

                                {{fooditem.title}}<br>
                            </p>

                        </v-col>
                    </v-row>
                    <v-row class="ma-0 pt-1">
                        <v-col cols="12" md="12">
                            <v-row v-if="fooditem.drinkitems.length" class="ma-0">
                                <v-col cols="6" md="6" v-for="(drinkitem, index) in fooditem.drinkitems" :key="'d'+index" class="ma-0 pa-0">
                                    <v-row class="ml-0 mr-0 pl-1 pr-1" style="max-width:100%" @click.prevent="drinkitemdetails(drinkitem.drinkid,drinkitem.typeid)">
                                        <v-col cols="4" md="4" class="pt-0 text-left pb-0 pa-0 ma-0">
                                            <v-img :src="drinkitem.image" :alt="drinkitem.typename" height="150px" contain/>
                                        </v-col>
                                        <v-col cols="8" md="8" class="pt-0 pb-0 pa-0 pl-1 ma-0">
                                            <div class="foodanddrink-title foodanddrink-text">{{drinkitem.name}}</div>
                                            <div class="foodanddrink-subtitle foodanddrink-text">{{drinkitem.subtitle}}</div>
                                            <div class="foodanddrink-strapline foodanddrink-text">{{drinkitem.typename}}</div>
                                            <div class="ma-0 pt-2">


                                                <v-col cols="12" md="12" class="pa-0 ma-0">
                                                        <v-row v-if="drinkitem.measures.length>0" class="detail-card-food-drink-pairing-row">
                                                            <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'ms'+index" class="pt-0 pb-0">
                                                                <!-- <div><span style="font-weight:bold;">Name :</span>{{measure.mname}} <span style="font-weight:bold;">Price :</span>{{measure.price}}<span style="font-weight:bold;"> Unit :</span><span>{{measure.qty}}</span> {{measure.unit}}</div> -->
                                                                <!-- <div>{{measure.mname}} <span class="pl-1 pr-1">{{measure.price}}</span><span class="pl-1 pr-1">{{measure.qty}}{{measure.unit}}</span> </div> -->
                                                                <v-row class="align-items: center">
                                                                    <v-col cols="4" md="4" class="detail-card-food-drink-measure foodanddrink-text">
                                                                        <span>{{measure.mname}}</span>
                                                                    </v-col>
                                                                    <v-col cols="3" md="3" class="detail-card-food-drink-unit foodanddrink-text">
                                                                        <span>{{measure.qty}} {{measure.unit}}</span>
                                                                    </v-col>
                                                                    <v-col cols="3" md="3" class="detail-card-food-drink-price foodanddrink-text">
                                                                        <!-- <i class="fa " :class="business.currency.icon" aria-hidden="true"></i> -->
                                                                        <span>{{parseFloat(measure.price).toFixed(2)}}</span>
                                                                        <!-- Drink Price Heart or Shopping Cart Icon                                                                                  -->
                                                                    </v-col>
                                                                    <!-- FOOD & DRINK PAIRING DETAIL FOOD CARD PAIRED Foodanddrink Add To Fav Icons-->
                                                                    <v-col cols="2" md="2" class="pb-0 pt-0 pl-0 custom-size">

                                                                            <v-col class=" paired-drink-fav-icon" v-if="checkitemfavoritedrink(drinkitem.drinkid,drinkitem.typeid,measure.mname)">
                                                                                <v-icon v-if="showcard==1"  size="16" color="#fe5800" @click.stop="togglefavdrinknew(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart</v-icon>
                                                                                <v-icon v-else-if="showcard==0"  size="16" color="#fe5800" @click.stop="togglefavdrinknew(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart</v-icon>
                                                                            </v-col>

                                                                            <v-col class=" paired-drink-fav-icon"  v-else>
                                                                                <v-icon v-if="showcard==1"  size="10" color="#949494" @click.stop="togglefavdrinknew(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart-outline</v-icon>
                                                                                <v-icon v-if="showcard==0"  size="10" color="#949494" @click.stop="togglefavdrinknew(drinkitem.drinkid,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart-outline</v-icon>

                                                                            </v-col>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                </v-col>
                                            </div>

                                        </v-col>

                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-divider class="pb-2" v-if="fooditem.drinkitems.length"></v-divider>

<!-- FOOD & DRINK PAIRING END  -->

                    <!-- TAP TO SEE MORE DETAILS                      -->
                    <!-- <v-row class="ma-0 pa-0" v-if="fooditem.allergens.length>=1 || fooditem.meats.length>=1">
                        <v-col cols="12" md="12" class="text-center pt-0 pb-0" style="color:#FE5800 !important; line-height: 0.5, text-transform:uppercase; font-size: 10px !important;">
                            <div class="pa-0">

                                {{$t('zz_tap_icon_for_full_details')}}

                            </div>
                        </v-col>
                    </v-row> -->
                        <v-col cols="12" class="mr-auto text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                           <v-icon style="top: 10%; right:0px; position:fixed; z-index=11" class="white-compact-cogs-75 cogtab " size="26" @click.stop="edititem(fooditem.id)">fa fa-cogs</v-icon>
                            <!-- <img :src="editicon" width="28" v-if=" $store.getters.user && $user.userType=='business' && business.id==$user.business.id"
                                                             @click.stop="edititem(fooditem.id)"/> -->
                        </v-col>
                    <!-- FOOD DETAIL CARD TITLE                              -->
                    <v-row class="ma-0">
                        <v-col cols="12" md="12" sm="12" class="pl-8 pr-8 pt-1">
                            <!-- <v-img :src="cheficonGrid" v-if="fooditem.foodstatus=='From Chef'" class="cheficonFoodDetailCard"/> -->
                            <div class="detail-card-food-title">
                                <!-- {{fooditem.title}} -->
                                <!-- {{userlangcode==''?fooditem.title:fooditem.langtransaltions[userlangcode].title}}<br> -->
                                {{itemdialog?(userlangcode=='' ?fooditem.title:fooditem.langtransaltions[userlangcode].title):fooditem.title}}


                            </div>
                            <!-- FOOD DETAIL CARD SUBTITLE                              -->
                            <div class="detail-card-food-subtitle">
                                <!-- {{fooditem.subtitle}} -->
                                {{itemdialog?(userlangcode=='' ?fooditem.subtitle:fooditem.langtransaltions[userlangcode].subtitle):fooditem.subtitle}}


                            </div>
                            <!-- CHILLI ICONS  -->
                            <v-row v-if="fooditem.chillispice>0" class="ma-0">
                                <!-- <v-col cols="12" class="pb-5 pl-8 pr-8">
                                    <p class="drink-detail-card-section-headings">Spicy</p></v-col> -->
                                <v-col cols="12" class="pa-0">
                                    <span v-for="n in 5" :key="n" class="pl-auto pr-auto">
                                        <img :src="n<=fooditem.chillispice?chilli:chillio" width="15">
                                    </span>
                                </v-col>
                            </v-row>

<!-- FOOD DETAIL CARD DESCRIPTION                              -->
                            <div class="detail-card-food-description">
                                <div v-html="itemdialog?(userlangcode=='' ?fooditem.description:fooditem.langtransaltions[userlangcode].description):fooditem.description"></div>
                                <!-- <div v-html="fooditem.description">
                                </div> -->
                            </div>
                        </v-col>
                    </v-row>



                    <v-divider></v-divider>


<!-- FOOD DETAIL CARD PRICE SECTION                              -->

                    <v-row class="ma-0">
                        <v-col cols="12" md="12" sm="12" class="pl-8 pr-8 pt-0">

<!-- FOOD DETAIL CARD PORTION/SIZE                              -->
                            <div class="pt-2">
                                <v-row v-if="fooditem.itemsize.length>0" class="detail-card-price-row">
                                    <v-col cols="12" v-for="(size, index) in fooditem.itemsize" :key="'sz-'+index" class="detail-card-price-row">
                                        <v-row cols="12" class="ml-2 mr-2">
                                            <v-col cols="6" md="6"  class="ml-0 mr-0 pa-0 detail-card-food-portion-text">
                                                {{size.size}}
                                            </v-col>

<!-- FOOD DETAIL CARD SPECIAL OFFER PRICE                              -->
                                                <v-col cols="5" md="5" class="detail-card-price-row">
                                                <span class="" v-if="size.special>0">
                                                    <span class="ml-0 mr-0 pa-0 detail-card-was-price strikethrough">
                                                        {{parseFloat(size.price).toFixed(2)}}
                                                    </span>
                                                    <span class="pt-0 pb-0 pl-2 pr-0 detail-card-now-price">
                                                    <!-- <span :style="[ business.themecolor!='' ?{'background': business.themecolor}:{'background': '#FE5800'} ]"
                                                    style="font-size:12px;" class="mr-2 white--text  specialprice "> -->
                                                        {{parseFloat(size.special).toFixed(2)}}
                                                    </span>

                                                </span>
                                                <span v-if="size.price>0.001" class="ml-0 mr-0 pa-0 detail-card-food-item-price">
                                                    {{parseFloat(size.price).toFixed(2)}}
                                                </span>
                                            </v-col>
                                            <v-col cols="1" md="1" class="ml-0 mr-0 pb-0 pt-0 pl-0 pr-2 custom-size">
                                                <v-row>
                                                    <v-col cols="12" class="price-row-favorite-icon" v-if="checkitemfavoritefood(fooditem.id,fooditem.courses[0].cid,size.size)">
                                                        <v-icon v-if="showcard==1"  size="16" color="#fe5800"  @click.stop="togglefav(fooditem.id,fooditem.courses[0].cid,coursename,size.price,fooditem.fimage,fooditem.title,fooditem.subtitle,size.size+'|'+size.price)">mdi-cart</v-icon>
                                                        <v-icon v-else-if="showcard==0"  size="16" color="#fe5800"  @click.stop="togglefav(fooditem.id,fooditem.courses[0].cid,coursename,size.price,fooditem.fimage,fooditem.title,fooditem.subtitle,size.size+'|'+size.price)">mdi-heart</v-icon>
                                                    </v-col>
                                                    <v-col cols="12" class="price-row-favorite-icon" v-else>
                                                        <v-icon v-if="showcard==1"  size="10" color="#949494"  @click.stop="togglefav(fooditem.id,fooditem.courses[0].cid,coursename,size.price,fooditem.fimage,fooditem.title,fooditem.subtitle,size.size+'|'+size.price)">mdi-cart-outline</v-icon>
                                                        <v-icon v-if="showcard==0"  size="10" color="#949494"  @click.stop="togglefav(fooditem.id,fooditem.courses[0].cid,coursename,size.price,fooditem.fimage,fooditem.title,fooditem.subtitle,size.size+'|'+size.price)">mdi-heart-outline</v-icon>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                            <!-- <div>
                                <v-col class="detial-card-food-description" cols="12"  v-html="fooditem.description"></v-col>
                            </div> -->
                        </v-col>

                    </v-row>



<!-- WARNING - ALLERGENS  TAP TO SEE MORE DETAILS -->


                    <v-row class="ma-0" v-if="fooditem.allergens.length>=1 || fooditem.meats.length>=1">
                        <v-col cols="12" md="12">
                        <!-- <div style="color:#FE5800;line-height: 0.5;">{{$t('zz_this_dish_contians_the_following_items')}}</div> -->
                         <!-- <v-divider class="pb-4 ml-0 mr-0"></v-divider> -->
                        <p class="detail-card-food-allergen-warning pl-8 pr-8">
                            {{$t('zz_this_dish_contians_the_following_items')}}</p>
                        </v-col>
                    </v-row>


                    <!-- <v-row class="ma-0 pa-0">
                        <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                            <v-col cols="12" class="text-center pa-0 ma-0">
                                <img class="allergen-icon-animation.shake" v-for="(allergen, index) in fooditem.allergens" :key="'p'+index" :src="allergen.image"  width="20" @click.prevent="foodAllergendetails(allergen.id,'allergens')"/>
                                <br>
                                <img class="cplr-1" v-for="(meat, index) in fooditem.meats" :key="'m'+index" :src="meat.image"  width="20" @click.prevent="foodAllergendetails(meat.id,'meat')"/>
                                <v-row class="ma-0 pa-0" v-if="fooditem.allergens.length>=1 || fooditem.meats.length>=1">
                                    <v-col cols="12" md="12" class="text-center pt-0 pb-0" style="color:#FE5800 !important; line-height: 1, text-transform:uppercase; font-size: 12px !important;">
                                        <div class="detail-card-allergen-icon-text">
                                            {{$t('zz_tap_icon_for_full_details')}}
                                        </div>

                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-col>
                    </v-row> -->



<!-- FOOD DETAIL CARD  LOWER SECTIONS  -->
<!-- MEATS & ALLERGEN ICONS With Banner Title -->

<!-- CHILLIS                     -->
                    <!-- <v-row v-if="fooditem.chillispice>0" class="ma-0">
                        <v-col cols="12" class="pb-15 pl-0 pr-0">
                            <p class="drink-detail-card-section-headings">Spicy</p></v-col>
                        <v-col cols="12" class="mt-0 pt-0 pl-3 pr-3"><span v-for="n in 5" :key="n" class="pl-auto pr-auto">
                            <v-icon :color="n<=fooditem.chillispice?'red':''" >mdi-chili-mild</v-icon>
                        </span></v-col>
                    </v-row> -->

<!-- ALLERGENS                      -->
                    <v-row v-if="fooditem.allergens.length>0" class="ma-0">
                        <v-col cols="12" class="pb-15 pl-0 pr-0">
                        <p class="drink-detail-card-section-headings">{{$t('zz_allergens')}}</p>
                        </v-col>
                        <v-col cols="3" v-for="(allergen, index) in fooditem.allergens" :key="'alg'+index" class="display-allergens pl-3 pr-3">
                            <!-- <img class="allergen-icon-animation.shake" v-for="(allergen, index) in fooditem.allergens" :key="'p'+index" :src="allergen.image"  width="20" @click.prevent="foodAllergendetails(allergen.id,'allergens')"/> -->
                            <img :src="allergen.image"  width="20"/>
                            <br>
                            <span v-html="allergen.name"></span>
                            <!-- {{allergen.name}} -->
                        </v-col>
                    </v-row>

<!-- MEATS                 -->
                    <v-row v-if="fooditem.meats.length" class="ma-0">
                        <v-col cols="12" class="pb-15 pl-0 pr-0">
                        <p class="drink-detail-card-section-headings">{{$t('zz_meat')}}</p>
                        </v-col>
                        <v-col cols="3" v-for="(meat, index) in fooditem.meats" :key="'m'+index" class="display-allergens pl-3 pr-3">
                            <img :src="meat.image"  width="20"/>
                            <br>
                            <span> {{meat.name}}  {{$t('zz_meat_name')}}</span>
                        </v-col>
                    </v-row>

                <div class="pb-10">
            </div>
             <!-- <v-divider></v-divider> -->
                        <p class="powered-by-juzzap">powered by juZZap</p>


<!-- NEW NUTRUITION PANEL ON FOOD DETAIL CARD  -->

                   <!-- <v-expansion-panels
                        v-model="panelnew"
                        multiple
                        style="width:100%;margin-top:5px;" class=""
                        flat>
                            <v-expansion-panel flat class="fooddetails-nutrition">
                                <v-expansion-panel-header flat style="background:#FE5800;color:#fff;">COMING SOON</v-expansion-panel-header>
                                <v-expansion-panel-content flat>
                                    <v-img :src="exampleimg"
                                    style="position:absolute;top: 165px;left: 50px;right: 50px;"/>
                                    <v-row class="ma-0">
                                        <v-col cols="12" md="12" class="text-center " style="font-size:46px;color:#fe5800;font-weight:bold;">
                                            NEW
                                        </v-col>
                                        <v-col cols="12" md="12" class="text-center " style="font-size:26px;color:#fe5800;font-weight:bold;">
                                            COMING EARLY 2021
                                        </v-col>

                                        <v-col cols="12" md="12" class="text-center " style="font-size:12px;color:#616161;font-weight:bold;">
                                            EXAMPLE OF CALORIE COUNT INFORMATION
                                        </v-col>
                                        <v-col cols="12" md="12" class="text-center" style="font-size:12px;color:#000">
                                            THIS SERVING CONTAINS
                                        </v-col>
                                        <v-col   class="pa-0 pr-1" >
                                            <div style="border:1px solid;border-radius:5px">
                                                <v-row class="ma-0">
                                                    <v-col cols="12" md="12" class="cpa-1 text-center" style="font-size:12px;">
                                                        <div style="font-weight:bold;font-size:12px;">ENERGY</div>
                                                        <div>924kj</div>
                                                        <div>220kcal</div>
                                                        <div>11%</div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col   class="text-center pa-0 pr-1" style="font-size:12px;" >
                                            <div style="background-color:#f8ac18;border:1px solid;border-radius:5px">
                                                <v-row class="ma-0">
                                                    <v-col cols="12" md="12" class="cpa-1 text-center" style="font-size:12px;">
                                                        <div style="font-weight:bold;">Fat</div>
                                                        <div>13g</div>
                                                        <div style="background-color:#fff;border-radius:4px;" class="">MED</div>
                                                        <div>19%</div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col   class="text-center pa-0 pr-1" style="font-size:12px;" >
                                            <div style="background-color:#f21117;border:1px solid;border-radius:5px">
                                                <v-row class="ma-0">
                                                    <v-col cols="12" md="12" class="cpa-1 text-center" style="font-size:12px;">
                                                        <div style="font-weight:bold;">SATURATES</div>
                                                        <div>5.9g</div>
                                                        <div style="background-color:#fff;border-radius:4px;" class="">HIGH</div>
                                                        <div>30%</div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col   class="text-center pa-0 pr-1" style="font-size:12px;" >
                                            <div style="background-color:#9fe50b;border:1px solid;border-radius:5px">
                                                <v-row class="ma-0">
                                                    <v-col cols="12" md="12" class="cpa-1 text-center" style="font-size:12px;">
                                                        <div style="font-weight:bold;">SUGARS</div>
                                                        <div>0.8g</div>
                                                        <div style="background-color:#fff;border-radius:4px;" class="">LOW</div>
                                                        <div>1%</div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col   class="text-center pa-0 pr-1" style="font-size:12px;" >
                                            <div style="background-color:#f8ac18;border:1px solid;border-radius:5px">
                                                <v-row class="ma-0">
                                                    <v-col cols="12" md="12" class="cpa-1 text-center" style="font-size:12px;">
                                                        <div style="font-weight:bold;">SALT</div>
                                                        <div>0.7g</div>
                                                        <div style="background-color:#fff;border-radius:4px;" class="">MED</div>
                                                        <div>12%</div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" style="font-size:12px;color:#000">
                                            <div>% of an adults reference intake.</div>
                                            <div>Typical value per 100g: Energy <span style="color:#fe5800">966Kj / 230 Kcal</span></div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12" class="text-justify pl-5 pr-5" style="font-size:12px;color:#000">
                                            We are pleased to announce that beginning 1st January 2021 juZZap will display full nutritional information for all food and beverages in keeping with the ‘NEW’ UK Obesity Law for out-of-home food and drink consumption.
                                            So, you can eat our more often safe in the knowledge of your calorie intake.
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                    </v-expansion-panels> -->

                    <v-row class="d-none ma-0">
                        <v-col cols="12" class="pb-0">
                            <h2 class="title">Add to your shortlist...</h2>
                        </v-col>
                        <v-col cols="12" >
                            <v-row v-for="(course, index) in fooditem.courses" :key="'c'+index" align="center">
                                <v-col cols="4">{{course.coursename}}</v-col>
                                <v-col cols="5"><v-text-field @change="setitemtotal(course.courseid)" @keyup="setitemtotal(course.courseid)" @input="setitemtotal(course.courseid)" value="0" :name="'course['+course.courseid+']'" @click:append-outer="addqty(course.courseid)" :id="'course-'+course.courseid"
                                    @click:prepend="subtractqty(course.courseid)" min="0" type="number" :data-price="course.price" label="Qantity" prepend-icon="mdi-minus-circle-outline" append-outer-icon="mdi-plus-circle-outline" v-model="itemqty"></v-text-field></v-col>
                                <v-col cols="3"><span class="mr-1" :id="'cp-'+course.courseid">{{parseFloat(course.price).toFixed(2)}}</span> </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" >
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12" >
                            <v-row>
                                <v-col cols="6"><strong>Total</strong></v-col>

                                <v-col cols="6" class="text-right"><strong class="mr-1" id="tp-total">0.00</strong> </v-col>

                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- <div class="mb-10 pb-10"></div> -->

                </v-card-text>


<!-- FULL WIDTH FOOTER WITH THEME BACKGROUND COLOUR  -->

                <!-- <v-footer
                :color= "business.themecolor!=''?business.themecolor:'#FE5800'">
                    <v-row>
                        <v-col cols="12" class="pa-0">
                            <v-row>
                                <v-col cols="4" class="pa-0">
                                    <v-btn text color="white" @click="backtomenu" ><v-icon>mdi-arrow-left</v-icon> Back</v-btn>
                                </v-col>
                                <v-col cols="8" class="text-right pa-0">
                                    <v-btn text color="white" @click="addtoorder" >
                                        <img :src="favplus" width="25"/> Favourites
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-footer> -->
            </v-card>

<!-- Food Detail Card FOOTER CLOSE BUTTON DIV  -->
            <v-footer
            absolute
            class="font-weight-medium ma-0"
            color="transparent">
                    <v-col
                        class="text-center"
                        cols="12">
                        <v-btn @click="backtomenu" fab small color="#fe5800" >
                            <v-icon class="white--text ">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
            </v-footer>
        </v-dialog>
<!-- END FOOD DETAIL CARD  -->



<!-- Order Detial Card order details popup -->




        <v-dialog v-model="orderdialog" content-class="createitemdialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

            <v-card v-if="orderdialog==true" tile class="" elevation="3" color="#fff">
                <ordercomponent   :orderdetail="order" :ordercourses="ordercourses" :business="business" v-on:set-dialog="backtofood" v-on:deleteitem="deleteorderitem" v-on:setordercoursesitem="updateorder" v-on:saveorderitem="saveorder"/>
            </v-card>



        </v-dialog>





<!-- DRINK DETAIL CARD VIA FOOD DETAIL CARD > PAIRED DRINK DETAIL CARD Popup -->

        <v-dialog class="drink-detail-card ma-0 pa-0" v-model="drinkitemdialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card tile class="drink-card-fullscreen ma-0 pa-0" elevation="3" v-show="drinkitemid>0" >
                <v-card-text class="pa-0">
                            <!-- REMOVE FOR LIVE COPY  -->
                            <!-- <span class="pt-3 drink-detail-card-title pulse ">PAIRED Drink Detail Card</span> -->
                                <v-row class="ma-0 pt-10">
                                    <v-col cols="5" class="pa-0 ma-0">
                                        <v-img contain :src="drinkitem.fimage" aspect-ratio="1" class="text-right drink-detail-card-drink-image">
                                        </v-img>
                                    </v-col>
                                    <v-col cols="7">
                                        <v-col>
                                            <v-row>
                                                <v-col cols="12" md="12" sm="12" class="">
                                                <div>
                                                    <div style="position:static" class="drink-detail-card-title">
                                                        {{drinkitem.name}}
                                                        <span cols="12" class="mr-auto text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                            <v-icon style="top: 10%; right:0px; position:fixed; z-index=11" class="white-compact-cogs-75 cogtab " size="26" @click.stop="edititem(fooditem.id)">fa fa-cogs</v-icon>
                                                            <!-- <v-icon style="top:30px; right:12px; position:absolute; z-index=7" class="compact-cogs-75">fa fa-cogs</v-icon> -->
                                                            <!-- <v-icon class="bbred pb-4 compact-cogs-100" size="16" color="#fe5800" @click.stop="editdrinkitem(drinkitem.id)"> -->
                                                                <!-- fa fa-cogs -->
                                                            <!-- </v-icon> -->
                                                        </span>
                                                    </div>
                                                    <div class="drink-detail-card-subtitle" style="line-height:1">
                                                        {{drinkitem.subtitle}}
                                                    </div>
                                                    <v-divider class="pb-4 pt-0 ml-0 mr-0"></v-divider>
    <!--  DRINK DETAIL CARD PRICE ROW -->
                                                    <v-col cols="12" md="12" class="pa-0 ma-0">
                                                            <v-row v-if="drinkitem.measures.length>0" class="detail-card-food-drink-pairing-row">
                                                                <v-col cols="12" v-for="(measure, index) in drinkitem.measures" :key="'dms-'+index" class="pt-0 pb-0">
                                                                    <!-- <div><span style="font-weight:bold;">Name :</span>{{measure.mname}} <span style="font-weight:bold;">Price :</span>{{measure.price}}<span style="font-weight:bold;"> Unit :</span><span>{{measure.qty}}</span> {{measure.unit}}</div> -->
                                                                    <!-- <div>{{measure.mname}} <span class="pl-1 pr-1">{{measure.price}}</span><span class="pl-1 pr-1">{{measure.qty}}{{measure.unit}}</span> </div> -->
                                                                    <v-row class="align-items: center">
                                                                        <v-col cols="4" md="4" class="detail-card-food-drink-measure foodanddrink-text">
                                                                            <span>{{measure.mname}}</span>
                                                                        </v-col>
                                                                        <v-col cols="3" md="3" class="detail-card-food-drink-unit foodanddrink-text">
                                                                            <span>{{measure.qty}} {{measure.unit}}</span>
                                                                        </v-col>
                                                                        <v-col cols="3" md="3" class="detail-card-food-drink-price foodanddrink-text">
                                                                            <!-- <i class="fa " :class="business.currency.icon" aria-hidden="true"></i> -->
                                                                            <span>{{measure.price}}</span>
                                                                            <!-- Drink Price Heart or Shopping Cart Icon                                                                                  -->
                                                                        </v-col>
                                                                        <!-- FOOD & DRINK PAIRING DETAIL FOOD CARD PAIRED Foodanddrink Add To Fav Icons-->
                                                                        <v-col cols="2" md="2" class="pb-0 pt-0 pl-0 custom-size">

                                                                                <v-col class=" paired-drink-fav-icon" v-if="checkitemfavoritedrink(drinkitem.id,drinkitem.typeid,measure.mname)">
                                                                                    <v-icon v-if="showcard==1"  size="16" color="#fe5800" @click.stop="togglefavdrinknew(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart</v-icon>
                                                                                    <v-icon v-else-if="showcard==0"  size="16" color="#fe5800" @click.stop="togglefavdrinknew(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart</v-icon>
                                                                                </v-col>

                                                                                <v-col class=" paired-drink-fav-icon"  v-else>
                                                                                    <v-icon v-if="showcard==1"  size="10" color="#949494" @click.stop="togglefavdrinknew(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-cart-outline</v-icon>
                                                                                    <v-icon v-if="showcard==0"  size="10" color="#949494" @click.stop="togglefavdrinknew(drinkitem.id,drinkitem.name,drinkitem.subtitle,drinkitem.image,drinkitem.typeid,drinkitem.typename,measure.mname+'|'+measure.price+'|'+measure.qty+'|'+measure.unit)">mdi-heart-outline</v-icon>

                                                                                </v-col>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                    </v-col>
                                                </div></v-col>
                                            </v-row>
                                        </v-col>
                                    </v-col>

                                    <v-col cols="12" md="12" sm="12" class="pl-8 pr-8 pt-5">
                                        <div class="drink-detail-card-description">

                                            <!-- ==============================
                                            <div> {{drinkitem.description}}
                                            </div>
                                            ============================== -->

                                            <div v-html="drinkitem.description">
                                            </div>
                                        </div>
                                    </v-col>
                            </v-row>

<!-- Drink categori detials  -->
                                <!-- <v-row v-if="drinkitem.categories.length>0" class="ma-0">
                                    <v-col cols="12" class="pb-0 pl-0 pr-0">
                                        <p class="drink-detail-card-section-headings">{{$t('zz_categories')}}</p>
                                    </v-col>
                                    <v-col cols="4" v-for="(category, index) in drinkitem.categories" :key="'p'+index" class="text-center pl-3 pr-3">
                                        <div>{{category.name}} </div>
                                    </v-col>
                                </v-row> -->

<!-- Drink Allergens  -->

                                <v-row class="ma-0" v-if="drinkitem.allergens.length>=1">
                                    <v-col cols="12" md="12">
                                    <!-- <div style="color:#FE5800;line-height: 0.5;">{{$t('zz_this_dish_contians_the_following_items')}}</div> -->
                                    <v-divider class="pb-4 ml-0 mr-0"></v-divider>
                                    <p class="detail-card-food-allergen-warning pl-8 pr-8">
                                        {{$t('zz_this_dish_contians_the_following_items')}}</p>
                                    </v-col>
                                </v-row>

                                <v-row v-if="drinkitem.allergens.length>0" class="ma-0">
                                    <v-col cols="12" class="pb-15 pl-0 pr-0">
                                    <p class="drink-detail-card-section-headings">{{$t('zz_allergens')}}</p>
                                    </v-col>

                                    <v-col cols="3" v-for="(allergen, index) in drinkitem.allergens" :key="'dal-'+index" class="display-allergens pl-3 pr-3">
                                        <img :src="allergen.image"  width="20"/>
                                        <br>
                                        <span v-html="allergen.name"></span>
                                        <!-- {{allergen.name}} -->
                                    </v-col>
                                </v-row>
                                <div class="pb-8"></div>

                                <!-- <v-divider></v-divider> -->
                                    <p class="powered-by-juzzap">powered by juZZap</p>
                            </v-card-text>
            </v-card>
            <v-footer
                absolute
                class="font-weight-medium "
                color="transparent">
                    <v-col class="text-center" cols="12">
                        <v-btn @click="backtodialog" fab small color="#fe5800" >
                            <v-icon class="white--text ">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
            </v-footer>
        </v-dialog>


<!-- Allergens Detail Card Popup -->

        <v-dialog v-model="allergensdialog" content-class="itemdetaildialog" scrollable
        fullscreen hide-overlay transition="dialog-bottom-transition">

            <v-card tile class="carddetail" elevation="3" color="#fff">

                <v-card-text class="pl-0 pr-0 pt-0 carddetail pb-8">
                    <v-img :src="allergensimg" />
                </v-card-text>
            </v-card>

            <v-footer
                absolute
                class="font-weight-medium "
                color="transparent">
                    <v-col
                        class="text-center"
                        cols="12"
                    >
                        <v-btn @click="backtodialogitem" fab small color="#fe5800" >
                            <v-icon class="white--text ">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
            </v-footer>
        </v-dialog>




    </div>
</template>


<script>
    import Vue from 'vue'
    import VeeValidate from "vee-validate";

    import { EventBus } from '@/event-bus';
    import Sticky from 'vue-sticky-directive';
    import {VueMasonryPlugin} from 'vue-masonry';
    import { Cropper } from 'vue-advanced-cropper';
    import AppBar from '@/components/AppBar.vue';

    import ordercomponent from '@/components/OrderComponent.vue';

    Vue.use(Sticky)
    Vue.use(VueMasonryPlugin)
    Vue.use(VeeValidate);

    export default
    {
        props:['business','order','isloaded','tag','countActivelang'],
        directives: {Sticky},
        data: () =>

        ({

            otype:'food',
            countActivelang1:0,
            founddesc:false,
            langdesc:'',
            showpayment:0,
            savedorder:[],
            showcard:0,

            nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 20) || 'Name must be less than 20 characters',
            ],
            emailRules:
            [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            stripe:'',
            createaccount:0,
            email:'',
            password: "",
            password_confirmation: "",
            ordername:'',
            orderpanel:[0,1],
            whatsappImg:require('@/assets/whatsaap.png'),
            whatsaapNumber:'',
            strmsg:'',


            //filterImg:require('@/assets/filters.png'),
            filterImg:require('@/assets/zz-filters.svg'),
            //filterImg:require('@/assets/Serpant-health-icon.svg'),
            allergenImg:require('@/assets/Serpant-health-icon.svg'),

            exampleimg:require("@/assets/EXAMPLE.svg"),
            editicon:require("@/assets/Pen-Icon-01.svg"),
            imgicon:require("@/assets/Camera-Icon-01.svg"),
            editimageicon:require("@/assets/editphotoicon.svg"),
            //allergensimg:require("@/assets/AllergensExplainedCard.svg"),
            allergensimg:require("@/assets/AllergensExplainedCard.svg"),
            panelnew:[0,1],
            filtera:0,
            chilli:require("@/assets/chili.svg"),
                // chillio:require("@/assets/chili-o.svg"),
            chillio:require("@/assets/chili-plain.svg"),

            romeoimg: require("@/assets/Jigsaw&.svg"),
            //romeoimg: require("@/assets/Jigsaw&.png"),

            imgfavplusdrink:require("@/assets/imgfavplusdrink.svg"),
            imgfavminusdrink:require("@/assets/imgfavminusdrink.svg"),
            valid:true,
            shw:true,
            nshw:false,
            fooditemshowonmenu:0,
            itemupdateid:0,
            itemupdatecourseid:0,
            mainimguploading:false,
            uploadedimage:null,
            overlayfooditemimageupdate:false,
            image:null,
            addphoto: require("@/assets/addphoto.svg"),

            drawer:null,
            businesscode:0,
            cocacolaImg:require('@/assets/cocacola2.gif'),
            overlaycocacola:false,
            orderoverlayPlain:false,
            overlayPIN:false,
            drinkoverlayPlain:false,
            overlayfooditem:false,
            overlayfooditemdetail: false,
            orderoverlay:false,
            orderrating:0,
            allergensrating:0,
            dietrating:0,
            meatrating:0,

            // descHTMLNo:'<p style="font-size:14px;" v-html="'+food.fdesc+'"></p>',
            star:0,
            stardiet:0,
            starmeat:0,
            allergensdialog:false,
            drinkitemdialog:false,
            itemdialog:false,
            itemimagedialog:false,
            itemdialogolddesign:false,
            paydialog:0,
            orderdialog:0,
            dietSelectAll:0,
            meatSelectAll:0,
            poultrySelectAll:0,
            panelfilter:[0,1,2],
            filter:0,
            filterAllergens:0,
            removedMeats:[],
            removedDiets:[],
            removedPoultrys:[],
            selectedMeats:[],
            selectedDiets:[],
            selectedPoultrys:[],
            selectedAllergens:[],
            selectedAllergensName:[],
            currentcourse:null,
            noAllergen:0,
            panel:[],
            panelAllergens:[0,1],
            drImg:require('@/assets/dr.png'),
            bannerImg:require('@/assets/overview-banner.jpg'),
            cheficonGrid:require('@/assets/chefGrid.svg'),
            cheficonList:require('@/assets/chefList.svg'),


            featureimg:require('@/assets/FaveActiveWhiteStroke.svg'),
            heart:require('@/assets/heart.png'),
            heartout:require('@/assets/heart-out.png'),
            // imgfavplus:require('@/assets/favplus.png'),
            imgfavplus:require('@/assets/FavsplusNew.svg'),
            imgfavminus:require('@/assets/FavminusNew.svg'),
            // imgfavminus:require('@/assets/favminus.png'),
            favplus:require('@/assets/favplus.svg'),
            ordercourses:{'courses':[{'items':[]}]},
            localorder:[],
            fooditem:
                {
                "id":0,
                "showonmenu":0,
                "business_id":0,
                "department_id":0,
                "title":"",
                "subtitle":"",
                "description":"",
                "image":"",

                "chillispice":0,
                "created_at":"",
                "updated_at":"",
                "foodstatus":"",
                "viewed":0,
                "ordered":0,
                "fimage":"",
                "itemsize":[],
                "meats":[],
                "diets":[],
                "poultrys":[],
                "allergens":[],
                "courses":[],
                "drinkitems":[],
                "langtransaltions":[],
                },

            foodview:'grid',

        // bannerImg:'',
            //logoImg:require('@/assets/logo.svg'),

            itemtotal:0,

            currentorder:[{items:[]}],
            fooditemid:0,
            courseid:0,
            itemqty:1,
            drinkitem:
            {

                "viewed":0,
                "ordered":0,
                "fimage":"",
                "image":"",
                "allergens":[],
                "measures":[],
                "units":[],
                "categories":[],
                "types":[],
            },
            drinkitemid:0,
            drinkitemname:'',
            attributes: {
                email: "E-mail Address",



            },
            coursename:"",
            userlangcode:'',

        }),
    components: {
        Cropper,
        AppBar,
        ordercomponent
	},
    created()
    {

        // this.userlangcode=localStorage.getItem('langcode')||'';
        console.log("business id "+this.business.id);
        this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }

        if(this.business.viewtype && this.business.viewtype!=null && this.business.viewtype!='null')
        {
            this.foodview=this.business.viewtype.toLowerCase();
        }
        else{
            this.foodview='list';
        }


    },

    watch:
    {
        business:function(value)
            {

                if(this.business.viewtype && this.business.viewtype!=null && this.business.viewtype!='null')
                {
                    this.foodview=this.business.viewtype.toLowerCase();
                }
                else{
                    this.foodview='list';
                }

                if(this.business.hastakeaway==1 || this.business.hasdelivery==1)
                {
                    this.showcard=1;
                }
                else
                {
                    this.showcard=0;
                }
                this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
                if(!this.userlangcode){
                this.userlangcode="";
                }

                return value;
            },
        selectedDiets:function(value)
        {
            return value;
        },
        selectedmeat:function(value)
        {
            return value;
        },
        selectedPoultrys:function(value)
        {
            return value;
        },
        order:function(value)
        {
            return value;
        },

        countActivelang:function(value)
        {
            this.countActivelang1=this.countActivelang;
            return value;
        }

    },
    mounted()
    {

        //this.business.activeBtn=4;

       this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }

    if(this.business.viewtype && this.business.viewtype!=null && this.business.viewtype!='null')
                {
                    this.foodview=this.business.viewtype.toLowerCase();
                }
                else{
                    this.foodview='list';
                }
        if(localStorage.getItem('order-'+this.business.id))
        {
            let corder=JSON.parse(localStorage.getItem('order-'+this.business.id));
            this.order.items=corder.items;
            this.order.name=corder.name?corder.name:'';
            this.order.phone=corder.phone?corder.phone:'';
            this.order.address1=corder.address1?corder.address1:'';
            this.order.address2=corder.address2?corder.address1:'';
            this.order.zip=corder.zip?corder.zip:'';
            this.order.town=corder.town?corder.town:'';



            this.order.ordertype=corder.ordertype?corder.ordertype:'';
          //  this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
        }else
        {
             localStorage.setItem('order-'+this.business.id,JSON.stringify({'ordertype':'','name':'','phone':'','address':'','items':[]}));
            this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
        }



        this.selectedMeats=this.business.meatids;
        this.selectedDiets=this.business.dietids;
        this.selectedPoultrys=this.business.poultryids;

       // this.business.fooditems.forEach(function(val,ind){
            //this.$redrawVueMasonry();
       // })




        let allids=localStorage.getItem('jzAllergens');
        let nAllergens=localStorage.getItem('jzNoAllergens');



        if(allids)
        {
            allids=JSON.parse(localStorage.getItem('jzAllergens'));
            this.selectedAllergens=allids;
            this.panel=[];

            this.setItemAllergen();
        }

        // if(nAllergens==1)
        // {
        //     this.panel=[];
        // }

        if (typeof this.$redrawVueMasonry === 'function') {
        this.$redrawVueMasonry()
      }

    },
    updated()
    {
      // var elem = document.querySelector('.grid');
      // var msnry = new Masonry('.grid', {
      //   // options
      //   itemSelector: '.grid-item',
      //   columnWidth: '50%'
      // });
    },
    computed:
    {
        ordertotal:function(){
            let total=0;
            this.order.items.forEach(function(item,inx){
                total+=parseFloat(item.qty)*parseFloat(item.price);
            })
            return parseFloat(total).toFixed(2);
        }
    },
    methods:
    {
        updateorder()
        {

            this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
        },
        backtofood()
        {
            this.orderdialog=false;



        },
        countactivelangbusiness()
        {
            this.$http
            .get(this.$apidomain+"checklangactive/" + this.business.id)
            .then(res =>
            {
                if (res.data.avtivelang==1 )
                {
                    //this.$router.push({name:'businesshome',params:{code: this.businesscode.trim(),type:'uc',key:this.getCookie('jzuserkey')}});
                    //this.$router.push({name:'bDetails',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});
                    //Again call this api for loader cocacola
                    this.countActivelang=1;
                    alert("active 1");
                }
                else if(res.data.avtivelang==0 )
                {
                this.countActivelang=0;

                }
            })
            .catch(err =>
            {



                //console.log(err.response);
            });
        },
        setlangcode(langcode){
              localStorage.setItem('langcode-'+this.business.id,langcode)
              this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
              if(!this.userlangcode){
                this.userlangcode="";
              }
          },
        foodstatusupdate(itemid,foodstatus)
        {

                this.$http
                .post(this.$apidomain+"itemfoodstatusupdate/"+itemid,{foodstatus:foodstatus})
                .then(res => {
                    if(res.data.success==1)
                    {


                        this.$router.go('/');
                    }



                })
                .catch(err => {
                    console.log(err.response);
                    //this.overlay=false;

                });

        },


        deleteItemCourse(itemcourseid)
        {
            if (confirm("Are you sure you want to delete this Items?"))
            {
                this.overlay=true;

                this.$http
                .post(this.$apidomain+"deleteitemcourse/"+itemcourseid)
                .then(res =>
                {

                    this.overlay=false;
                    this.$router.go('/');


                })
                .catch(err => {
                    console.log(err.response);
                });
            }
        },

        whatsapmsg()
        {


            let th=this;




            let newstr=[];

            let whatsaapMsg="";

            th.whatsaapNumber=th.business.whatsapp;




            let total=0;

            if(th.ordercourses.courses.length>0)
            {
                let itemfound=false;
                let ordertotal=0;

                let paymentmode='';

                th.strmsg="\n\n\n*CLIENTE*\n\n";


                th.strmsg+="_"+th.order.name+"_\n\n";

                if(th.order.ordertype=='Delivery'){

                    th.strmsg+="\n"+th.order.address1;
                    th.strmsg+="\n"+th.order.address2;
                    th.strmsg+="\n"+th.order.city+", "+th.order.town;
                    th.strmsg+="\n"+th.order.zip;



                    if(th.order.paymentmode!='')
                    {
                        th.paymentmode=th.order.paymentmode;
                    }


                }

                let allAllerText="";

                let allAllergenname="";

                allAllergenname=JSON.parse(localStorage.getItem('jzAllergensName'));



                if(allAllergenname)
                {
                    allAllergenname.forEach(function(allergen,ind){



                        allAllerText+=allergen.replace('<br>',' ')+', ';
                    })

                    allAllerText=allAllerText.substr(0,allAllerText.length-1);

                }

                if(allAllerText=='')
                {
                    th.strmsg+="\n\n*ALLERGENS:* None declared  \n\n";

                }
                else
                {
                    th.strmsg+="\n\n*ALLERGENS:* "+allAllerText+" \n\n";
                }

                th.strmsg+="*Notes:* \n";


                th.strmsg+=th.order.phone;


                th.strmsg+="\n\n.............................\n";

                th.strmsg+="*"+th.business.businessName+"* \n";

                th.strmsg+=this.$domain+"businessDetails/"+th.business.businesscode+"/drink \n\n";


                th.strmsg+="*TYPO:"+th.order.ordertype+"*";
                th.strmsg+="\n.............................\n";



                th.ordercourses.courses.forEach(function(item,index){

                    if(item.items.length>0)
                    {

                        th.strmsg+="\n\n*"+item.coursename+"*\n\n";

                        item.items.forEach(function(it,ind){
                            if(it.qty>0 && it.price>0)
                            {
                                th.strmsg+=it.qty+" X "+it.title+" = "+th.business.currency.symbole+(parseFloat(it.qty)*parseFloat(it.price)).toFixed(2)+"\n";
                                ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                            }
                        })




                    }



                })

                th.strmsg+="\n..........................\n";



                th.strmsg+="*Total :"+th.business.currency.symbole+ordertotal.toFixed(2)+"*";

                th.strmsg+="\n\n";

                if(th.paymentmode!='')
                {
                    th.strmsg+="*Payment Mode* :"+th.paymentmode;


                    th.strmsg+="\n\n";

                }


                th.strmsg+="*DELIVERY CHARGES:* \n";

                if(parseFloat(ordertotal)>parseFloat(th.business.deliveryfreeorder))
                {
                    th.strmsg+="FREE This is on us, Thanks For Your Order \n";

                }
                else
                {
                    th.strmsg+="If you order just another "+th.business.currency.symbole+(parseFloat(th.business.deliveryfreeorder)-parseFloat(ordertotal)).toFixed(2)+" you will save the delivery fee.";

                }




                //th.strmsg+="\n\n powered by juZZap \n\n";





                whatsaapMsg="https://wa.me/"+th.business.whatsapp+"/?text="+encodeURIComponent(th.strmsg);

                window.location=whatsaapMsg;



            }
        },

        saveorder()
        {
            let th=this;


            let msg="";
            let response="";
            if (this.$refs.form.validate())
            {

                let fd = new FormData(document.getElementById("createorder"));

                if(th.ordercourses.courses.length>0)
                {
                    let ordertotal=0;

                    let orderitems=[];

                    let createaccount=0;

                    if(th.createaccount)
                    {
                        createaccount=1;
                    }
                    else
                    {
                        createaccount=0;
                    }

                    fd.append('createaccount',createaccount);


                    fd.append('name',th.order.name);

                    fd.append('orderid','order-'+th.business.id)

                    fd.append('businesses_id',th.business.id)

                    fd.append('paymentmode',th.order.paymentmode)

                    th.ordercourses.courses.forEach(function(item,index)
                    {

                        if(item.items.length>0)
                        {


                            item.items.forEach(function(it,ind){
                                if(it.qty>0 && it.price>0)
                                {
                                    orderitems.push({'product_type':it.type,'course_id':it.courseid,'product_name':it.title,'product_id':it.itemid,'qty':it.qty,'price':it.price,'total':parseFloat(it.qty)*parseFloat(it.price)});
                                    ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                                }
                            })

                        }



                    })

                    fd.append('ordertotal',ordertotal);

                    fd.append('addressline1',th.order.address1);

                    fd.append('addressline2',th.order.address2);

                    fd.append('city',th.order.city);

                    fd.append('town',th.order.town);

                    fd.append('zip',th.order.zip);

                    fd.append('notes',th.order.phone);

                    fd.append('orderitems',JSON.stringify(orderitems));







                }

                this.$http
                .post(this.$apidomain+"createorder", fd)
                .then(res =>
                {
                    th.msg=res.data.msg;
                    th.response=res.data.success;



                        if(res.data.success==1)
                        {
                            this.savedorder=res.data.ordermaster;
                            if(res.data.key.clientSecret!='' && this.business.paymentenabled==1)
                            {

                                this.stripe = this.business.stripapikey;
                                if(this.business.stripapikey!=''){
                                    var stripe = Stripe(this.stripe);
                                    let elements = stripe.elements();

                                    let card = elements.create("card");

                                    // Stripe injects an iframe into the DOM

                                    var style = {

                                        base: {

                                            color: "#32325d",

                                            fontFamily: 'Arial, sans-serif',

                                            fontSmoothing: "antialiased",

                                            fontSize: "16px",

                                            "::placeholder": {

                                            color: "#32325d"

                                            }

                                        },

                                        invalid: {

                                            fontFamily: 'Arial, sans-serif',

                                            color: "#fa755a",

                                            iconColor: "#fa755a"

                                        }

                                        };

                                    card.mount("#card-element", { style: style });
                                    th.showpayment=1;
                                    document.querySelector("#payment-form button").disabled = true;

                                    card.on("change", function (event)
                                    {

                                        // Disable the Pay button if there are no card details in the Element

                                        document.querySelector("#payment-form button").disabled = event.empty;

                                        document.querySelector("#card-error").textContent = event.error ? event.error.message : "";

                                    });

                                    var form = document.getElementById("payment-form");

                                    form.addEventListener("submit", function(event) {

                                    event.preventDefault();

                                    // Complete payment when the submit button is clicked

                                    th.payWithCard(stripe, card, res.data.key.clientSecret);

                                    });
                                }
                            }




                            //th.whatsapmsg()

                        }



                })
                .catch(err => {
                    //this.overlay=false;

                 console.log(err.response);
                });



           }
        },

        payWithCard(stripe, card, clientSecret)
        {

            this.loading(true);

            let th=this;

            stripe

                .confirmCardPayment(clientSecret, {

                payment_method: {

                    card: card

                }

                })

                .then(function(result) {

                if (result.error) {

                    // Show error to your customer

                    th.showError(result.error.message);

                } else {

                    // The payment succeeded!

                    th.orderComplete(result.paymentIntent.id);

                }

                });

        },

        orderComplete(paymentIntentId)
        {
         // console.log('payment id'+paymentIntentId);

            let th=this

            let savedorderid=this.savedorder.id;

            this.loading(false);


            document.querySelector(".result-message").classList.remove("hidden");

            document.querySelector("#payment-form button").disabled = true;

            let bodyFormData = new FormData();

            bodyFormData.append('paymentid', paymentIntentId);


            this.$http
                .post(this.$apidomain+"updateorder/"+savedorderid, bodyFormData)
                .then(res =>
                {
                    //alert(res.data.success);
                    localStorage.setItem('order-'+this.business.id,JSON.stringify({'ordertype':'','name':'','phone':'','address':'','items':[]}));
                    this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));

                    this.showpayment=0;
                    this.ordercourses={'courses':[{'items':[]}]};


                })

        },


        showError(errorMsgText)
        {

            this.loading(false);

            var errorMsg = document.querySelector("#card-error");

            errorMsg.textContent = errorMsgText;

            setTimeout(function() {

                errorMsg.textContent = "";

            }, 4000);

        },



        loading(isLoading)
        {

            if (isLoading)
            {




                document.querySelector("#payment-form button").disabled = true;

                document.querySelector("#spinner").classList.remove("hidden");

                document.querySelector("#button-text").classList.add("hidden");

            } else
            {

                document.querySelector("#payment-form button").disabled = false;

                document.querySelector("#spinner").classList.add("hidden");

                document.querySelector("#button-text").classList.remove("hidden");

            }

        },


        updateshowitem(itemid,courseid,showitem)
        {
            //this.overlay=true;

            //  let showitem=showitem;
            //showitem= document.getElementById('showonitem-'+itemid).value;

            // console.log('show item value ' + showitem+' itemid '+itemid);

                this.$http
                .post(this.$apidomain+"updateitemcourseshow/"+itemid+"/"+courseid,{showitem:showitem})
                .then(res => {
                    if(res.data.success==1)
                    {


                        this.$router.go('/');
                    }



                })
                .catch(err => {
                    console.log(err.response);
                    //this.overlay=false;

                });

        },
        uploadImage(event)
        {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
                    this.mainimguploading=true;

					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
        },
        onChange({coordinates, canvas})
        {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
            this.image = canvas.toDataURL()
            this.mainimguploading=false;

        },

        createfooditem()
        {
            this.$router.push({name:'createfooditem',params:{id:this.business.id}});
        },
        logout()
        {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/");
            });
        },
        getStyle()
        {
            return{
            'background':'#e5e5e50',
            'border-color':this.storeBusiness.themecolor

            }
        },

        favminus(itemid)
        {
            let th=this;
            let res=false;

                th.order.items.forEach(function(item){
                    if(itemid==item.itemid)
                    {
                        //console.log('remove item');
                        //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                        this.order.items.splice(itemid,1);

                        localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

                    }
                    else
                    {

                        th.order.items.push({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});

                    }
                });
        },
        togglefavdrink(drinkitemid,title,subtitle,img,courseid,coursename,type)
        {



                let th=this;
            let res=false;
            //alert('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img+ ' courseid ' + courseid + ' coursename ' + coursename+' type '+type);
            //console.log('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price );
            this.fooditemid=drinkitemid;
            this.drinkitemid=drinkitemid;
            if(th.order.items.length>0)
            {
                let itemfound=false;
                th.order.items.forEach(function(item,index){
                    if(drinkitemid==item.itemid && courseid==item.courseid)
                    {

                        th.order.items.splice(index,1);

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        itemfound=true;
                        //console.log('order minus');
                    }

                });
                if(!itemfound)
                {
                    //alert(drinkitemid+','+title+','+subtitle+','+img+','+courseid+','+coursename+','+'drink')

                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':0,'total':0,'type':'drink'});
                    //res=false;
                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();
                }
            }
            else
            {
                //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':0,'type':'drink'});
                        //res=false;
                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':0,'total':0,'type':'drink'});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                   this.addtoorder();


            }

            this.drinkitemdialog=false;
            this.orderdialog=false;


        },
        adddrinkorder()
        {
            //console.log('Call Addorder');
            let th=this;
            let qty=0;


            this.$http
            .get(this.$apidomain+"drinkitemorderedupdate/"+this.drinkitemid+'/plus')
            .then(res => {

            })
            .catch(err => {
            console.log(err.response);
            });

        },
        togglefav(itemid,courseid,coursename,price,img,title,subtitle,size='')
        {
            let th=this;
            let res=false;
            let sz=[];
            let it=0;
            let ip=0;

            //console.log('size '+size);

            //console.log('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price +'size '+ size);
            this.fooditemid=itemid;

            if(size)
            {
                sz=size.split('|');

                //alert(sz[0]);
                //console.log('check size '+size);



                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index)
                    {
                        if(sz[0]=='null')
                        {
                            //alert('remove');
                            if(itemid==item.itemid && courseid==item.courseid && (item.mname=="" || item.mname=="null"))
                            {

                                //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                                th.order.items.splice(index,1);

                                localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                                itemfound=true;
                                //console.log('order minus');
                            }
                        }
                        else
                        {
                            //alert('not remove');

                            if(itemid==item.itemid && courseid==item.courseid && item.mname==sz[0])
                            {

                                //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                                th.order.items.splice(index,1);

                                localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                                itemfound=true;
                               // console.log('order minus');
                            }
                        }

                    });
                    if(!itemfound)
                    {


                        if(sz[0]!='')
                        {
                            it=title+'-'+sz[0];

                        }
                        else
                        {
                            it=title;

                        }
                        ip=sz[1];

                        //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'food'});
                        th.order.items.push({'itemid':itemid,'image':img,'title':it,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'food','mname':sz[0]});

                        //res=false;
                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        this.addtoorder();
                    }
                }
                else
                {




                    if(sz[0]!='')
                    {
                        it=title+'-'+sz[0];

                    }
                    else
                    {
                        it=title;

                    }
                    ip=sz[1];

                    //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'food'});
                            //res=false;
                    th.order.items.push({'itemid':itemid,'image':img,'title':it,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'food','mname':sz[0]});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();


                }
            }


        },
        addtoorder()
        {

            //console.log('Call Addorder');
            let th=this;
            let qty=0;
            th.fooditem.courses.forEach(function(course)
            {
            //let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
            let itemqty=1;
            qty=qty+itemqty;
            let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
            let itemtotal=itemprice*itemqty;
            if(itemtotal>0)
            {
               // console.log('cid'+course.cid);
                //th.order.items.push({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
            }

            })
            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

            //console.log('fooditemid'+this.fooditemid)  ;

            if(qty==0)
            {
                qty=1;
            }
            this.$http
            .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+qty+'/plus')
            .then(res => {

            })
            .catch(err => {
            console.log(err.response);
            });


            // this.resetfoodtem();
            //  this.itemdialog=false;
            //  this.overlayfooditem=false;

        },
        checkitemfavorite(itemid,courseid)
        {
            let th=this;
            let res=false;

                //alert(itemid+','+courseid);

                th.order.items.forEach(function(item){
                    if(itemid==item.itemid && courseid==item.courseid)
                    {
                        res=true;
                        //alert(res);
                    }

                });
            return res;

        },
        checkitemfavoritefood(itemid,courseid,size='')
        {
            let th=this;
            let res=false;

                // alert(itemid+','+courseid+' '+size);

                if(size!=""  && size!=null)
                {
                    th.order.items.forEach(function(item)
                    {



                            if(itemid==item.itemid && courseid==item.courseid && size==item.mname)
                            {
                                res=true;
                                // alert(itemid+','+courseid+' '+size);
                            }




                    });
                }
                else
                {
                    th.order.items.forEach(function(item)
                    {

                            //console.log('else size '+size);

                            if(itemid==item.itemid && courseid==item.courseid && (item.mname=="null" || item.mname==""))
                            {
                                res=true;
                                // alert(itemid+','+courseid+' '+size);
                            }


                          //  console.log('res '+res);

                    });

                }
            return res;
        },

        togglefavdrinknew(drinkitemid,title,subtitle,img,typeid,typename,measure='')
        {
            //console.log('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img);

            //alert('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img+' typeid '+typeid+' typename '+typename);

            let th=this;
            let res=false;
            this.drinkitemid=drinkitemid;
            let ma=[];
            let it=0;
            let ip=0;
            if(measure)
            {
                ma=measure.split('|');

                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index)
                    {
                        if(drinkitemid==item.itemid && item.mname==ma[0])
                        {
                            th.order.items.splice(index,1);
                            //localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));
                            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                            itemfound=true;
                            //console.log('order minus');

                        }


                    });
                    if(!itemfound)
                    {
                        it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                        ip=ma[1];

                        // th.order.items.push({'drinkid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'typeid':typeid,'typename':typename});

                        // localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));



                        th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':typeid,'course':typename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink','mname':ma[0]});

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                        this.addtoorder();

                    }
                }
                else
                {

                    // th.order.items.push({'drinkid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'typeid':typeid,'typename':typename});

                    // localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));
                    it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                    ip=ma[1];

                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':typeid,'course':typename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink','mname':ma[0]});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));


                    this.addtoorder();
                }
            }







        },

        checkitemfavoritedrink(itemid,typeid,mname='')
        {
            let th=this;
            let res=false;




                th.order.items.forEach(function(item){
                    if(itemid==item.itemid && typeid==item.courseid && mname==item.mname)
                    {
                        res=true;

                    }

                });
            return res;

        },
        addqty(itemid,courseid)
        {

        },
        setview(vw,containerid){
            this.foodview=vw;
             if (typeof this.$redrawVueMasonry === 'function') {
        this.$redrawVueMasonry()
      }

        },
        redrawmasonry(containerid){
            if(this.foodview=='grid'){
                this.$redrawVueMasonry(containerid);
            }

        },
        reduceqty(itemid,courseid)
        {
            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {
                    //th.order.items.splice(index,1);
                    if(item.qty>0)
                    {
                        item.qty--;
                        item.total=parseFloat(item.qty)*parseFloat(item.price);

                    }
                }
            });

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();
        },
        setordertype()
        {

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();

            if(this.order.ordertype=='Delivery')
            {
                //alert('delivery');
                this.orderpanel=0;
            }
            else
            {
                this.orderpanel=1;

            }
        },
        addorderqty(itemid,courseid)
        {
            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {
                    //th.order.items.splice(index,1);
                    item.qty++;
                    item.total=parseFloat(item.qty)*parseFloat(item.price);
                }
            });

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();
        },
        deleteorderitem(itemid,courseid){

            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {
                    th.order.items.splice(index,1);

                }
            });
          // this.order.items.splice(ind,1);

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();


            // this.$http
            //   .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+delitem.qty+'/minus')
            //   .then(res => {

            //    })
            //   .catch(err => {
            //     console.log(err.response);
            //   });

            //this.calculatetotals();


          },
        setRemovedMeats()
        {
            let th=this;
            if(this.meatSelectAll==0)
            {
                th.business.meatids.forEach(function(meatid,index){
                    th.removedMeats.push(meatid);
                })
                this.meatSelectAll=1;
            }else{
                this.meatSelectAll=0;
                this.removedMeats=[];
            }
            this.setItemMeat();
        },
        setRemovedPoultrys()
        {
            let th=this;
            if(this.poultrySelectAll==0)
            {
                th.business.poultryids.forEach(function(poultryid,index){
                    th.removedPoultrys.push(poultryid);
                })
                this.poultrySelectAll=1;
            }else{
                this.poultrySelectAll=0;
                this.removedPoultrys=[];
            }
            this.setItemMeat();
        },
        setRemovedDiets()
        {
            let th=this;
            if(this.dietSelectAll==0)
            {
                th.business.dietids.forEach(function(dietid,index){
                    th.removedDiets.push(dietid);
                })
                this.dietSelectAll=1;
            }else{
                this.dietSelectAll=0;
                this.removedDiets=[];
            }
            this.setItemDiet();
        },
        toggleDiet(dietid)
        {
            //    if(this.business.dietids.indexOf(dietid)==-1)
            //     {

            //         this.business.dietids.push(dietid);
            //         this.removedDiets.splice(this.removedDiets.indexOf(dietid),1);
            //     }else{
            //         this.business.dietids.splice(this.business.dietids.indexOf(dietid),1);

            //         this.removedDiets.push(dietid);
            //     }

            if(this.removedDiets.indexOf(dietid)==-1)
            {

               // this.selectedDiets.push(dietid);
                 this.removedDiets.push(dietid);
            }else{
                //this.selectedDiets.splice(this.business.dietids.indexOf(dietid),1);

                this.removedDiets.splice(this.removedDiets.indexOf(dietid),1);

            }

           this.setItemDiet();
        },
        toggleMeat(meatid)
        {
            // if(this.business.meatids.indexOf(meatid)==-1)
            // {
            //     this.business.meatids.push(meatid);
            //     this.removedMeats.splice(this.removedMeats.indexOf(meatid),1);

            // }else{
            //     this.business.meatids.splice(this.business.meatids.indexOf(meatid),1);
            //     this.removedMeats.push(meatid);

            // }

            if(this.removedMeats.indexOf(meatid)==-1)
            {

                this.removedMeats.push(meatid);

            }else{

                this.removedMeats.splice(this.removedMeats.indexOf(meatid),1);


            }
            this.setItemMeat();
        },
        togglePoultry(poultryid)
        {
            // if(this.business.poultryids.indexOf(poultryid)==-1)
            // {
            //     this.business.poultryids.push(poultryid);
            //     this.removedPoultrys.splice(this.removedPoultrys.indexOf(poultryid),1);

            // }else{
            //     this.business.poultryids.splice(this.business.poultryids.indexOf(poultryid),1);
            //     this.removedPoultrys.push(poultryid);

            // }
            if(this.removedPoultrys.indexOf(poultryid)==-1)
            {

                this.removedPoultrys.push(poultryid);


            }else{

                this.removedPoultrys.splice(this.removedPoultrys.indexOf(poultryid),1);

            }
            this.setItemPoultry();
        },
        setItemMeat()
        {
            let th=this;
           // let courses = Object.keys(this.business.fooditems)
            for(let [key,value] of Object.entries(th.business.fooditems)){

                    value.forEach(function(item,ind,arr){
                        th.business.fooditems[key][ind].hasmeat=1;
                        th.removedMeats.forEach(function(selectedmeat,index){
                            if(item.meatids.indexOf(selectedmeat)!=-1){
                                //console.log('meat id meat'+th.business.fooditems[key][ind].title);
                                th.business.fooditems[key][ind].hasmeat=0;
                            }
                        })
                    })

            }

        },
        setItemDiet()
        {
            let th=this;
           // let courses = Object.keys(this.business.fooditems)
            for(let [key,value] of Object.entries(th.business.fooditems)){

                    value.forEach(function(item,ind,arr){
                        th.business.fooditems[key][ind].hasdiet=1;
                        th.removedDiets.forEach(function(selecteddiet,index){
                            if(item.dietids.indexOf(selecteddiet)!=-1){
                                th.business.fooditems[key][ind].hasdiet=0;
                            }
                        })
                    })

            }

        },
        setItemPoultry()
        {
            let th=this;
           // let courses = Object.keys(this.business.fooditems)
            for(let [key,value] of Object.entries(th.business.fooditems)){

                    value.forEach(function(item,ind,arr){
                        th.business.fooditems[key][ind].hasdiet=1;
                        th.removedPoultrys.forEach(function(selectedpoultry,index){
                            if(item.poultryids.indexOf(selectedpoultry)!=-1){
                                th.business.fooditems[key][ind].haspoultry=0;
                            }
                        })
                    })

            }

        },
        noAllergens()
        {
            this.selectedAllergens=[];
            this.panel=[];
            localStorage.setItem('jzNoAllergens',1);
            localStorage.setItem('jzAllergens','');
            this.setItemAllergen();

        },
        setItemAllergen()
        {
            let th=this;
           // let courses = Object.keys(this.business.fooditems)
            for(let [key,value] of Object.entries(th.business.fooditems)){

                    value.forEach(function(item,ind,arr){
                        th.business.fooditems[key][ind].hasallergen=0;
                        th.selectedAllergens.forEach(function(selectedallergen,index){
                            if(item.allergenids.indexOf(selectedallergen)!=-1){
                                th.business.fooditems[key][ind].hasallergen=1;
                            }
                        })
                    })

            }

        },
        saveAllergens()
        {

            localStorage.setItem('jzAllergens',JSON.stringify(this.selectedAllergens));
            localStorage.setItem('jzAllergensName',JSON.stringify(this.selectedAllergensName));

            this.setItemAllergen();
            this.panel=[];
            this.filterAllergens=0;
        },
        addAllergens(allergenid,allergenname)
        {
            if(this.selectedAllergens.indexOf(allergenid)==-1)
            {
                this.selectedAllergens.push(allergenid);
            }else{
                this.selectedAllergens.splice(this.selectedAllergens.indexOf(allergenid),1);
            }

            if(this.selectedAllergensName.indexOf(allergenname)==-1)
            {
                this.selectedAllergensName.push(allergenname);
            }else{
                this.selectedAllergensName.splice(this.selectedAllergensName.indexOf(allergenname),1);
            }
        },
        resetfoodtem()
        {
            this.fooditem= {
            "id":0,
            "showonmenu":0,
            "business_id":0,
            "department_id":0,
            "title":"",
            "subtitle":"",
            "description":"",
            "image":"",
            "chillispice":0,
            "created_at":"",
            "updated_at":"",
            "foodstatus":"",
            "viewed":0,
            "ordered":0,
            "fimage":"",
            "itemsize":[],
            "meats":[],
            "diets":[],
            "poultrys":[],
            "allergens":[],
            "courses":[],
            "drinkitems":[],
            };
            this.fooditemid=0;
            this.courseid=0;
            if(localStorage.getItem('order-'+this.business.id)){
            this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
          }else{
            localStorage.setItem('order-'+this.business.id,JSON.stringify({'items':[]}));
            this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
          }
        },
        fooditemimage(fiid,crid,showonmenu)
        {
            if(this.itemdialog)
            {
                this.itemdialog=false;
            }
            if(this.orderdialog)
            {
                this.orderdialog=false;
            }
            this.itemimagedialog=true;
            this.itemupdateid=fiid;
            this.itemupdatecourseid=crid;
            this.fooditemshowonmenu=showonmenu;


        },
        dataURLtoFile(dataurl, filename)
        {

                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }

                return new File([u8arr], filename, {type:mime});
        },
        updateimage()
        {
            let fd = new FormData(document.getElementById("editfooditem"));

            if(this.uploadedimage!=null){
                fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
            }

            this.overlayfooditemimageupdate=true;

             this.$http
            .post(this.$apidomain+"updateItemImage/"+this.itemupdateid, fd)
            .then(res => {
                if(res.data.success==1)
                {

                    this.itemimagedialog=false;
                    this.overlayfooditemimageupdate=false;


                    // this.$router.push({name:'food',params:{tag:this.business.id,key:''}});
                    // this.$router.push({name:'businessfoodlist'});
                    this.$router.go('/');

                }
                else
                {
                    this.overlay=false;
                    this.itemimagedialog=false;

                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    alert(errmsg[0]);
                }
            })
            .catch(err => {
                    this.overlay=false;

                    console.log(err.response);
            });

        },
        drinkitemdetails(drinkitemid)
        {
            if(this.drinkitemdialog==true)
            {
                this.drinkitemdialog=false;
            }
            else
            {
                this.drinkitemdialog=true;
                this.drinkoverlayPlain=true;

                this.$http
                .get(this.$apidomain+"drinkitemDatanew/"+drinkitemid)
                .then(res =>
                {
                    this.drinkitem = res.data.item;

                    this.drinkitemid = drinkitemid;


                    this.drinkoverlayPlain=false;


                })
                .catch(err => {
                    console.log(err.response);
                    this.drinkoverlayPlain=false;

                });

            }

        },

        foodAllergendetails(id,type)
        {
            if(this.allergensdialog==true)
            {
                this.allergensdialog=false;
            }
            else
            {
                this.allergensdialog=true;
            }
        },
        fooditemdetails(fiid,crid,type,separator)
        {
           // this.$router.push({name:'eventdetails',params:{id: eventid,businessid:this.business_id}});
          // this.$emit('eventclick',eventid);

            //this.orderdialog=false;
            //alert(type);
            if(separator){
                return false;
            }
            if(this.itemimagedialog==true)
            {
                this.itemdialog=false;

            }
            else
            {




                //this.overlayPIN=true;

                if(type=='food')
                {

                    if(this.business.sponsored==1)
                    {
                        this.overlayPIN=true;
                        this.overlaycocacola=true;
                    }
                    else
                    {
                        this.overlayfooditem=true;
                        this.orderoverlayPlain=true;
                    }



                    this.$http
                    .get(this.$apidomain+"fooditemDatanew/"+fiid+'/'+crid)
                    .then(res =>
                    {
                        this.fooditem = res.data.item;

                        this.fooditemid = fiid;

                        this.courseid = crid;

                        this.coursename=this.fooditem.courses[0].coursename;




                        this.$http
                            .get(this.$apidomain+"itemviewupdate/"+fiid)
                            .then(res => {
                                this.overlayfooditem=false;
                                this.itemdialog=true;
                                this.overlayPIN=false;

                                this.overlaycocacola=false;
                                this.orderoverlayPlain=false;

                            })
                            .catch(err => {
                            console.log(err.response);
                            this.overlayPIN=false;

                            this.overlaycocacola=false;
                            this.orderoverlayPlain=false;
                        });
                    //this.itemdialog=1;
                    })
                    .catch(err =>
                    {
                        console.log(err.response);
                        this.overlayPIN=false;

                            this.overlaycocacola=false;
                            this.orderoverlayPlain=false;
                    });
                    //EventBus.$emit('fooditemclick', {'fooditemid':fooditemid,'courseid':courseid});

                }

                if(type=='drink')
                {

                    this.orderoverlayPlain=true;
                    // this.drinkitemdialog=true;
                    // this.drinkitemid=fiid;

                    this.$http
                    .get(this.$apidomain+"drinkitemDatanew/"+fiid)
                    .then(res =>
                    {
                        //this.drinkitem = res.data.item;


                        this.drinkitem = res.data.item;


                        this.drinkitemid = fiid;
                        this.courseid = crid;


                        this.drinkitemdialog=true;


                        this.itemoverlayPlain=false;

                        this.orderoverlayPlain=false;


                        // this.$http
                        //     .get(this.$apidomain+"itemviewupdate/"+fiid)
                        //     .then(res => {
                        //         this.overlayfooditem=false;
                        //         this.itemdialog=true;
                        //         this.overlayPIN=false;

                        //         this.overlaycocacola=false;
                        //         this.orderoverlayPlain=false;

                        //     })
                        //     .catch(err => {
                        //     console.log(err.response);
                        // });
                        //this.itemdialog=1;
                    })
                    .catch(err => {
                        console.log(err.response);
                        this.itemoverlayPlain=false;
                        this.orderoverlayPlain=false;

                    });

                }



            }
        },
        addqty(courseid)
        {
            document.getElementById('course-'+courseid).value = parseInt(document.getElementById('course-'+courseid).value)+1;
            //console.log(document.getElementById('course-'+courseid).getAttribute('data-price')*parseInt(document.getElementById('course-'+courseid).value));
            this.setitemtotal(courseid);
        },

        subtractqty(courseid)
        {
            if(parseInt(document.getElementById('course-'+courseid).value)>0){
              document.getElementById('course-'+courseid).value = parseInt(document.getElementById('course-'+courseid).value)-1;

               // this.itemtotal=(document.getElementById('course-'+courseid).getAttribute('data-price')*parseInt(document.getElementById('course-'+courseid).value)).toFixed(2) ;
              this.setitemtotal(courseid);
            }
        },

        setitemtotal(courseid)
        {
              let total=0;
              this.fooditem.courses.forEach(function(course){
                let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
                let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
                let itemtotal=itemprice*itemqty;

                total=total+itemtotal;
              });
              document.getElementById('tp-total').innerHTML=parseFloat(total).toFixed(2);
        },

        editdrinkitem(itemid)
        {
            this.$router.push({name:'editbusinessdrinkitem',params:{id:itemid}});

        },

        edititem(itemid){
            this.$router.push({name:'editfooditem',params:{id:itemid}});
        },
        backtomenuimage()
        {
            this.uploadedimage=null;
            this.itemimagedialog=false;
            this.overlayfooditem=false;

        },
        backtomenu(){
            this.resetfoodtem();

            this.itemdialog=false;

            this.overlayfooditem=false;
        },
        backtodialog()
        {
            this.drinkitemdialog=false;
        },
        backtodialogitem()
        {
            this.allergensdialog=false;
        },
        backtomenuorder()
        {
            this.orderdialog=0;

        },
        closepayorder()
        {
            this.paydialog=0;
        },
        setordercourses(){
            if(this.order.items.length>0)
            {
                let th=this;
                th.ordercourses={'courses':[{'items':[]}]};

                th.order.items.forEach(function(item,index){
                    if(th.ordercourses.courses.length==0){
                        let cr={
                            courseid:item.courseid,
                            coursename: item.course,
                            type:item.type,
                            items:[]
                        };
                        cr.items.push(item);
                        th.ordercourses.courses.push(cr);
                    }
                    else{
                        let coursefound=false;
                        th.ordercourses.courses.forEach(function(course,ind){
                            if(course.courseid==item.courseid && course.type==item.type){
                               // course.items.push($item);
                                th.ordercourses.courses[ind].items.push(item);
                                coursefound=true;
                            }
                        });
                        if(!coursefound){
                            let cr={
                                courseid:item.courseid,
                                coursename: item.course,
                                type:item.type,
                                items:[]
                            };
                            cr.items.push(item);
                            th.ordercourses.courses.push(cr);
                        }
                    }
                });
            }
            else
            {
                this.ordercourses={'courses':[{'items':[]}]};

            }
        },
        gotoorder()
        {
          this.orderoverlay=true;
          this.setordercourses();
          //this.$router.push({'name':'order'});
          this.showpayment=0;
          this.orderdialog=1;
          this.orderoverlay=false;
        }
    }
}


</script>




<style>

.footer-1{
    /* opacity: .75; */
    background-color: rgba(255, 255, 255, 0.75) !important;
    z-index: 100;
    flex-flow: row wrap;

}
.footer-buttons{
    background-color: #FE5800;
    color: white !important;
}
    .foodmain .lh12{
    line-height:12px !important;
    }

    .foodmain .lh1{
    line-height:1 !important;
    }

    .max-400{
        max-width:400px !important;
        align-items: flex-start;
    }

    .pwa-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    }

    .pwa-container .pwa-items{
    flex: 0 1 150px; /*  No stretching: */
    margin: 5px;
    }

    .carddetail .dlh12{
    line-height:12px !important;
    }

    .custom-size .v-messages{
    min-height:0px !important
    }

    .drinkradio .v-input--selection-controls__input{
    display:none;
    }

    .cardlistnone{
    max-width: 100%;
    border-radius:none;
    border:none !important;
    box-shadow: none !important;
    }



    /* base: {

    color: #32325d;

    fontFamily: Arial, sans-serif;

    fontSmoothing:antialiased;

    fontSize:16px;


    } */




    /* FOOD ORDER CARD STYLING STARTS HERE  */

    .order-card{
        min-height: 100%;
        min-width: 100%;
        padding-top: 10px;
        position: fixed;
        left: 0;
        top: 0;
        /* background: rgba(0, 238, 255, 0.7); */
        /* z-index: 10; */
    }

    .order-card-image{
        align-content: stretch;
        vertical-align: middle;
        max-height: 75px;

    }

    .order-card-title{
        padding-top: 12px;
        color: rgb(61, 61, 61);
        font-size:12px;
		font-weight: 400;
        text-transform:capitalize;
        line-height: 12px;
        padding-left: 12px;
        text-align: left;

        /* font-size: 12px;
        line-height: 1 !important;
        font-weight: 400;
        text-align: left;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 12px !important;
        padding-right: 0px !important;
        color: crimson; */

    }

    .order-card-subtitle{
        padding-top: 10px;
        color: rgb(61, 61, 61);
        font-size:10px;
		font-weight: 300;
        /* text-transform:capitalize; */
        line-height: 12px;
        padding-left: 12px;
        text-align: left;



        /* font-size: 10px;
        line-height: 1 !important;
        font-weight: 400;
        text-align: left;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 12px !important;
        padding-right: 0px !important;
        color: crimson; */

    }

    .order-card-price{
        font-size: 12px;
        line-height: 1 !important;
        font-weight: 300;
        text-align: right;
        padding-top: 0px !important;
        padding-bottom: 5px !important;
        padding-left: 0px !important;
        padding-right: 5px !important;
        color: #FE5800;
        /* background-color: #FE4800 !important;  */

/*
        font-size: 12px;
        font-weight: 300;
        color: #FE5800;
         */
    }

    .order-card-qty{
        line-height: 1;

    }

    .order-card-title-divider{
        position:relative;
        height: 20px;

        padding-bottom: 15px;
        background-color:#ffffff ;
    }
    /* .order-card-title-divider:before{ */
        /* position:absolute;
        content:"";
        height:2px;
        background:#f3db05;
        top:50%;
        left:0px;
        right:0px;
        z-index: 1;
    } */

    .order-card-divider-text{
        font-size: 20px;
        line-height: 1 !important;
        font-weight: 400;
        text-align: left;
        padding-top: 0px !important;
        padding-bottom: 20px !important;
        padding-left: 12px !important;
        padding-right: 0px !important;
        color: rgb(35, 35, 35);
        background-color: #ffffff !important;


    }


    form#payment-form {

    width: 80vw;



    align-self: center;

    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),

    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);

    border-radius: 7px;
    }

    form#payment-form input {

    border-radius: 6px;

    margin-bottom: 6px;

    padding: 12px;

    border: 1px solid rgba(50, 50, 93, 0.1);

    height: 44px;

    font-size: 16px;

    width: 100%;

    background: white;

    }

    .foodmail .result-message {

    line-height: 22px;

    font-size: 16px;

    }

    .result-message a {

    color: rgb(89, 111, 214);

    font-weight: 600;

    text-decoration: none;

    }

    .hidden {

    display: none;

    }

    #card-error {

    color: rgb(105, 115, 134);

    text-align: left;

    font-size: 13px;

    line-height: 17px;

    margin-top: 12px;

    }

    #card-element {

    border-radius: 4px 4px 0 0 ;

    padding: 12px;

    border: 1px solid rgba(50, 50, 93, 0.1);

    height: 44px;

    width: 100%;

    background: white;

    }

    #payment-request-button {

    margin-bottom: 32px;

    }

    /* Buttons and links */

    form#payment-form button {

    background: #5469d4;

    color: #ffffff;

    font-family: Arial, sans-serif;

    border-radius: 0 0 4px 4px;

    border: 0;

    padding: 12px 16px;

    font-size: 16px;

    font-weight: 600;

    cursor: pointer;

    display: block;

    transition: all 0.2s ease;

    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);

    width: 100%;

    }

    form#payment-form button:hover {

    filter: contrast(115%);

    }

    form#payment-form button:disabled {

    opacity: 0.5;

    cursor: default;

    }


    .spinner,

    .spinner:before,

    .spinner:after {

    border-radius: 50%;

    }

    .spinner {

    color: #ffffff;

    font-size: 22px;

    text-indent: -99999px;

    margin: 0px auto;

    position: relative;

    width: 20px;

    height: 20px;

    box-shadow: inset 0 0 0 2px;

    -webkit-transform: translateZ(0);

    -ms-transform: translateZ(0);

    transform: translateZ(0);

    }

    .spinner:before,

    .spinner:after {

    position: absolute;

    content: "";

    }

    .spinner:before {

    width: 10.4px;

    height: 20.4px;

    background: #5469d4;

    border-radius: 20.4px 0 0 20.4px;

    top: -0.2px;

    left: -0.2px;

    -webkit-transform-origin: 10.4px 10.2px;

    transform-origin: 10.4px 10.2px;

    -webkit-animation: loading 2s infinite ease 1.5s;

    animation: loading 2s infinite ease 1.5s;

    }

    .spinner:after {

    width: 10.4px;

    height: 10.2px;

    background: #5469d4;

    border-radius: 0 10.2px 10.2px 0;

    top: -0.1px;

    left: 10.2px;

    -webkit-transform-origin: 0px 10.2px;

    transform-origin: 0px 10.2px;

    -webkit-animation: loading 2s infinite ease;

    animation: loading 2s infinite ease;

    }

    @-webkit-keyframes loading {

    0% {

        -webkit-transform: rotate(0deg);

        transform: rotate(0deg);

    }

    100% {

        -webkit-transform: rotate(360deg);

        transform: rotate(360deg);

    }

    }

    @keyframes loading {

    0% {

        -webkit-transform: rotate(0deg);

        transform: rotate(0deg);

    }

    100% {

        -webkit-transform: rotate(360deg);

        transform: rotate(360deg);

    }

    }

@media only screen and (max-width: 600px) {

  form#payment-form form {

    width: 80vw;

  }

}
    .food-list-item.col-12{
    padding:5px;
}

    .order-delivery-panel .v-expansion-panel::before {
    box-shadow:none;
    }
    .order-delivery-panel .v-expansion-panel-header{
        padding: 16px 0px;
    }
    .order-delivery-panel .v-expansion-panel-content__wrap {
        padding: 0px !important;
    }
    .v-input--radio-group--row .v-input--radio-group__input .v-radio
    {
        margin-right:12px !important;
    }

    .v-slide-group__next .theme--light.v-icon--disabled, .v-slide-group__prev .theme--light.v-icon--disabled
    {
        color:#fe5800 !important;

    }
    .v-slide-group.v-item-group > .v-slide-group__next .v-icon.v-icon, .v-slide-group.v-item-group > .v-slide-group__prev .v-icon.v-icon
    {
        color:#fe5800 !important;

    }
    .v-slide-group__prev.theme--light.v-icon
    {
        color:#fe5800 !important;

    }
    .v-slide-group__next.theme--light.v-icon
    {
        color:#fe5800 !important;

    }
    .v-slide-group__next, .v-slide-group__prev {
        min-width:10px !important;
        color:#fe5800 !important;
    }
    .v-tab--active
    {
        background:#FE5800 !important;
        color:#fff !important;
        caret-color:#fff !important;
    }

    .v-application .subtitle-1
/* <This is the sticky course name that appears when you scroll down and header goes our of view */
    {
        font-size: 14px !important;
        /* font-weight: 600; */
        background:#313131 !important;
        color:#fff !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
        margin-bottom: 0px !important;

    }

.business-logo-top-center{
    /* This appears on Food and Drink pages  */
    max-height: 40px;
    max-width: 100%;
    text-align: center;
    justify-content: center;
}

.allergen-filter-icon{
    /* This appears on Food and Drink pages  */
    align-content: center;
    text-align: center;
    max-height: 30px;

}

.allegen-filter-text{
        font-size: 12px;
        line-height: 1;
        font-weight: 300;
        color: #313131;
        text-align: justify;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 10px;
        margin-top: 10px;

        /* color: rgb(48, 48, 48);
        padding-top: 5px !important;
        padding-bottom: 20px !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
        font-size:12px;
        font-weight: 300;
        line-height:1;
        text-align: justify; */


}

.center-center-content{
    align-content: stretch;
    vertical-align: middle;
}

.foodmain .mid-mid{
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: auto;
    padding-right: auto;
    /* margin-left: auto; */
    /* margin-right: auto; */
    margin: auto;

}

.allergen-filter-title{
    font: 14px;
    font-weight: 800;
    color: #FE5800;
    padding-bottom: 0px !important;
}

.allergen-filter-icon-label{
    /* This appears on Food and Drink pages  */
    font-size: 8px;
    line-height: 8px;
    margin-top: 0px;
    color: #FE5800;
    padding-top: 5px;
}

.fixed-course-heading
/* <This is the sticky course name that appears when you scroll down and header goes our of view */
    {
        vertical-align: middle;
        /* min-height: 32px; */
        line-height: 14px;
        font-size: 14px !important;
        font-weight: 600;
        /* background:#fff !important; */
        /* color:#FE5800 !important; */
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
        margin-bottom: 0px !important;
        border-bottom-right-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;


    }


    .cplr-1
    {
        margin-left: 2px;
        margin-right: 2px;
    }
    .fooddetails-nutrition.v-expansion-panel::before
    {
        box-shadow:none;
    }
    .cpa-1
    {
        padding:4px;
    }
    .chili-size .v-icon.v-icon
    {
        font-size:18px !important;
    }
    .fooditemimg .v-responsive__content
    {
        display: none !important;
    }
    .backimg v-image__image
    {
        background-size: contain;
    }
    .masonry-brick {
    width: 50%;
    padding:4px;
    }
    .masonry-brick-full
    {
    width: 100%;
    padding:5px;

    }
    .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 10px !important;
    }
    .mt-8{
        padding-top: 50px;
    }
    .mb-8
    {
        padding-bottom: 50px;
    }


/* ########### FOOD CARDS ########### */

/* Food Course Menu Banner Top of Food Course */


    .food-course-top-banner
    {
        padding-left: 5px;
        padding-right: 5px;
        margin-left: 5px;
        margin-right: 5px;
        margin-top: 10px;
        margin-bottom: 5px;


    }

/* ######### Food Course Menu Top Banner Generic #######*/

    .foodmain .food-course-top-banner-title{
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 5px;
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        margin-top: 10px;
    }

    .foodmain .food-course-top-banner-price{
        font-size: 12px;
        font-weight: 600;
        color: #333333;
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

    .foodmain .food-course-top-banner-price-text{
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

    .foodmain .food-course-top-banner-description{
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        color: #333333;
        text-align: justify;
        padding-top: 0px;
        padding-bottom: 5px;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 10px;
        margin-top: 10px;

    }


/* ################ Paired Pairing Drink Detail Card from Food Detail Card Drink ############### */

    .redtest{
        color: crimson !important;
    }

    .wbgtest{
        background-color: white;

    }



/* ################ This is for the Food detail Card > Drink detials Card only  */
    .drink-detail-card-drink-image{
        /* max-height: 100%; */
        background-color: white  !important;
        /* align-content: flex-end; */
        padding-left: 15px;
        width: 100% !important;

    }


    .drink-detail-card-section-headings{
        color: rgb(255, 255, 255);
        background-color:#FE5800;
        font-size:12px;
		line-height: 12px;
        font-weight: 500;
        text-align: left;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-transform:capitalize;
        vertical-align: middle;
        border-radius: 0px;
    }

    .drink-detail-card-title{
/* ################ Both Drink Detail Cards      */
        font-size:18px !important;
        /* line-height: 13px !important; */
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(48, 48, 48);
        padding-top: 15px;
        padding-bottom: 5px;
        padding-left: 0px;
        text-transform:uppercase;
        text-align: left;
        vertical-align: middle;
        line-height: 1;
    }

    .drink-detail-card-subtitle{
/* ################ Both Drink Detail Cards      */
        color: rgb(48, 48, 48);
        font-size:14px;
		font-weight: 500;
        /* text-transform:capitalize; */
        /* background-color:#1b1b1b; */
        padding-left: 0px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        /* margin-bottom: 15px; */
        text-align: left;
        vertical-align: middle;
        border-radius: 3px;
        line-height: 1;
    }

    .drink-detail-card-strapline{
        padding-top: 10px;
        color: rgb(61, 61, 61);
        font-size:14px;
		font-weight: 500;
        text-transform:capitalize;
        line-height: 12px;
        padding-left: 12px;
        text-align: left;

    }


    .drink-detail-card-description{
        font-size:12px !important;
        font-weight: 300 !important;
        line-height:1 !important;
        text-align: justify !important;
        font-family: "Roboto", sans-serif !important;
        color: rgb(61, 61, 61) !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
        padding-bottom:0 !important;
        padding-left: 0 !important;

        /* background-color: pink !important; */

    }

/* .detail-card-food-description
    {
        color: rgb(48, 48, 48);
        padding-top: 10px;
        padding-bottom:;
        padding-left: ;
        padding-right: ;
        margin-bottom: ;
        font-size:12px;
        font-weight: 300;
        line-height:1;
        text-align: justify;


    } */


    .paired-drink-detail-card-price-row{
        /* border-top:1px solid #fe5800 !important; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 40px;
        padding-right: 40px;
        line-height: 1;
        margin: 0px;
    }

    .paired-drink-detail-card-price-icon{
        font-size: 10px !important;
        line-height: 10px !important;
        padding: 0px;
        margin: 0px;
    }


    .paired-drink-detail-card-measure
        {
            padding-top: 0px;
            padding-bottom: 0px;
            padding-left: 0px;
            padding-right: 0px;
            font-size:10px !important;
            line-height: 13px !important;
            font-weight:300;
            text-align:left;
            color: #949494;
            text-transform:uppercase;
        }

    .paired-drink-detail-card-unit
        {
            padding-top: 0px;
            padding-bottom: 0px;
            padding-left: 0px;
            padding-right: 0px;
            font-size:10px !important;
            line-height: 13px !important;
            font-weight:300;
            text-align:left;
            color: #949494;
            text-transform:uppercase;
        }

    .paired-drink-detail-card-price
        {
            padding-top: 0px;
            padding-bottom: 0px;
            padding-left: 0px;
            padding-right: 5px !important;
            font-size:10px !important;
            line-height: 13px !important;
            font-weight:300;
            text-align:right;
            color: #949494;
            text-transform:uppercase;
        }

        .paired-drink-fav-icon{
            padding-top: 0px;
            padding-bottom: 0px;
            padding-left: 5px;
            padding-right: 0px;
            align-items: center;
        }

    .drink-detail-card .drink-card-fullscreen{
        min-height: 100%;
        min-width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 238, 255, 0.7);
        z-index: 10;
    }

    /* .drink-detail-card .itemdetaildialog .theme--light.v-card > .v-card__text {
        color: #000;
    }

    .drink-detail-card.itemdetaildialog,.orderdetaildialog{
        padding: 10px;
        background: #e806f0;
        text-decoration: none;

    } */

    .foodmain .cardlist{

        max-width: 960px;
        /*max-height: 150px;*/
        border-top-right-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
    }

    /* DRINK DETAIL CARD CHILD STYLING  */
    .itemdetaildialog .carddetail,.orderdetaildialog .carddetail
    {
        /* color:white !important; */
        /* background: rgb(231, 231, 231) !important; */
        /* border-top-right-radius: 100px !important; */
        /* border-bottom-left-radius: 100px !important; */
        text-decoration: none;


    }
    .cardchef
    {
        border-top-right-radius: 0px !important;
    }


    .price-row-favorite-icon{
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
        align-items: right !important;
        /* width: 50px; */
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: baseline;
    }


    .favorite{
        text-align: center;
        align-items: center !important;
        display: flex;
        justify-content: center;
    }

    .favorite-count-cart{
        display: flex;
        justify-content: center;
        color:rgb(255, 255, 255);
        position:relative;
        left: 50%;
        top: -7%;
        font-size: 8px;
        font-weight: 600;
        z-index:3;
        text-align: center;

    }




    .favorite-count-heart{
        display: flex;
        color: rgb(255, 255, 255);
        position: relative;
        left: 50%;
        top: -3%;
        font-size: 10px;
        font-weight: 600;
        z-index: 7;


    }

    .grid-list-icons{
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        margin-left: 0px;
        margin-right: 0px;
    }



/* ################ LIST VIEW FOOD ITEM PRICE CLASSES START HERE  */

    /* .foodmain .row-list{
        margin-right: 0px !important;

    } */

    .foodmain .divider-line.noimagecard {
        color: #f3f3f3;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
        border: 2px;
        border-style: solid;
        /* box-shadow: 2px 2px 5px 5px #a7a7a7; */



    }

    .foodmain .cardborder-listView
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        position: relative;
        margin-bottom: 25px !important;

    }

    .foodmain .food-shape-photo-listView
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 0px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 0px;
        width: 100%;

    }

    .fooddesc
    {
        font-size:12px;
        font-weight: 500;
    }

    .food-title-listView-c
    {
        font-size:14px !important;
        line-height: 13px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(48, 48, 48);
        text-transform:uppercase;
        text-align: center;
        padding: 0px;
    }

    .foodmain .food-subtitle-listView-c{
        /* padding-top: 10px; */
        color: rgb(61, 61, 61);
        font-size:12px;
		font-weight: 500;
        /* text-transform:capitalize; */
        line-height: 13px;
        text-align: center;
    }


    .foodmain .food-description-listView-c{
        /* max-block-size: 80%; */
        color: rgb(48, 48, 48);
        padding-right: 0px !important;
        padding-top: 5px;
        padding-bottom: 10px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:10px;
        font-weight: 300;
        line-height:1;
        text-align: center;
        /* max-height: 100px; */

    }

    .foodmain .food-price-row-listView-c{
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        color: #989898;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px !important;
        justify-content: flex-end;
        text-align: right;

    }

    .chilli-icons-listView-c{
        text-align: center;
    }


    .foodmain .food-title-listView
    {
        font-size:14px !important;
        line-height: 13px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(48, 48, 48);
        text-transform:uppercase;
        text-align: left;
    }

    .foodmain .food-subtitle-listView{
        /* padding-top: 10px; */
        color: rgb(61, 61, 61);
        font-size:12px;
		font-weight: 500;
        /* text-transform:capitalize; */
        line-height: 13px;
        text-align: left;
    }


    .foodmain .food-description-listView{
        /* max-block-size: 80%; */
        color: rgb(48, 48, 48);
        padding-right: 0px !important;
        padding-top: 5px;
        padding-bottom: 10px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:10px;
        font-weight: 300;
        line-height:1;
        text-align: left;
        /* max-height: 100px; */

    }

    .chilli-icons-listView{
        text-align: left;
    }

    .foodmain .food-price-row-listView{
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        color: #989898;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px !important;
        justify-content: flex-end;
        text-align: right;

    }

    .chilli-icons{
        text-align: center;
    }


    .foodmain .food-price-listView{
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        color: #989898;
        padding-top: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 12px;
        padding-right: 0px;
        text-align: right;
    }

/* Portion Text  */
    .foodmain .food-portion-text-listView
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size: 9px !important;
        line-height: 13px !important;
        font-weight:300;
        color: #989898;
        text-transform:uppercase;
        text-align: left;
    }

/* New Price - Now Price  */
    .foomain .food-now-price-listView
    {

        padding-top: 0px;
        padding-bottom: 0px;
        color: #989898;
        outline-style: thin;
        stroke-width: 2px;
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        padding-left: 2px;
        padding-right: 2px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;
        margin-right: 0px;
        text-align: right;
    }

/* This is the striked through price shown when an item is discounted  */
    .was-price-listView
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-right: 0px;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        color: #989898;
        text-decoration:none;
        /* text-decoration-color: #FE5800; */
        /* text-align: end; */
    }

        .strikethrough {
        position: relative;
        }

        .strikethrough:before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        right: 0;
        border-top: 1px solid;
        border-color: #FE5800;

        -webkit-transform:rotate(-10deg);
        -moz-transform:rotate(-10deg);
        -ms-transform:rotate(-10deg);
        -o-transform:rotate(-10deg);
        transform:rotate(-10deg);
        }

/* LIST VIEW FOOD ITEM PRICE CLASSES END HERE  */


/* IMAGE ZOOM EFFECT  */







/* ################ GRID VIEW FOOD ITEM PRICE CLASSES START HERE  */

    .foodmain .food-row-grid-text {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 20px !important;
        padding-right: 20px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;

    }


    .foodmain .card-shape-grid
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        padding: 0px;

    }

    .foodmain .image-shape-grid
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;

    }

    /* .fooddesc
    {
        font-size:12px;
        font-weight: 500;
    } */

    .foodmain .food-title-gridView
    {
        font-size:14px !important;
        line-height: 13px !important;
        font-weight:600 !important;
        /* color: rgb(20, 20, 20); */
        text-transform:uppercase !important;
        padding-top: 10px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        /* margin-top: 10px !important; */
        color: #525252 !important;
    }

    .food-subtitle-gridView{
        font-size:12px !important;
		font-weight: 400 !important;
        line-height: 11px !important;
        padding-top: 1px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        text-align: left !important;
        margin-left: 0px !important;
        color: #525252 !important;
    }


    .foodmain .food-description-grid{
        font-size:10px;
        font-weight: 300;
        line-height: 10px !important;
        text-align: justify;
        max-block-size: 80%;
        /* color: rgb(48, 48, 48); */
        padding-top: 3px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px !important;

        /* max-height: 100px; */

    }

    .foodmain .food-price-row-grid{
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        /* color: #414141; */
        padding-top: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 12px;
        padding-right: 0px;
    }


    .food-item-portion-text-grid
    {

        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        text-transform:capitalize;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

    .special-offer-price-grid
    {
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;

    }
/* This is the striked through price shown when an item is discounted  */

    .was-price-grid
    {
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        text-decoration:none;
        /* text-decoration-color: #fe0000; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-left: 0px;
    }

    .food-item-price-text-grid{
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;

    }


    .featureitem .special-offer-price-grid
    {

        color: #ffffff;


    }
/* This is the striked through price shown when an item is discounted  */

    .featureitem  .was-price-grid
    {

        color: #ffffff;

    }

    .featureitem  .food-item-price-text-grid{

        color: #ffffff;


    }
.whitebackground{
    background-color: white;
    border-radius: 3px;



}

/* GRID VIEW FOOD ITEM PRICE CLASSES END HERE  */



/* ################ FOOD DETAIL CARD END ################ */

    .detail-card-food{
        border-top-right-radius: 0px;
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
        border-bottom-left-radius: 0x !important;

    }

    .detail-card-food-border
    {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .detail-card-food-photo
    {
        /* max-height: 400px; */
        border-top-left-radius: 10px;
        border-top-right-radius: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 0px;
    }

    .detail-card-food-chef-banner
    {
        border-top-right-radius: 25px !important;
        border-top-left-radius: 25px !important;
        position:absolute;
        bottom:0px;
        left:0px;
        text-align:center;
        width:100%;
        height:41px;
        line-height:41px;

    }

    .detail-card-food-allergen-warning{
        font-size:10px !important;
        line-height: 1 !important;
        font-weight:400;
        color: rgb(255, 0, 0);
        text-transform:uppercase;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        text-align: center;


    }

    .detail-card-allergen-icon-text{
        font-size:10px !important;
        line-height: 1 !important;
        font-weight:200;
        color: rgb(44, 44, 44);
        text-transform:uppercase;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;


    }

    .display-allergens{
        color: rgb(42, 42, 42);
        font-size:12px;
		font-weight: 300;
        text-transform:capitalize;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;
        /* vertical-align: middle; */
        vertical-align: text-top;
        line-height: 10px;

    }


    .detail-card-food-title
    {
        font-size:24px !important;
        line-height: 24px !important;
        font-weight:800;
        color: rgb(44, 44, 44);
        text-transform:uppercase;
        padding-top: 1px;
        padding-bottom: 0px;

        }

    .detail-card-food-subtitle
    {
        color: rgb(110, 110, 110);
        font-size:18px !important;
        font-weight:400;
        padding-top: 0px;
        padding-bottom: 0px;

    }


    .detail-card-food-description
    {
        color: rgb(48, 48, 48);
        padding-top: 10px;
        padding-bottom:0;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 0;
        font-size:12px;
        font-weight: 300;
        line-height:1;
        text-align: justify;


    }

    .food-price-section{
        position: absolute;
        bottom: 10px;
        right: 10px;

    }

    .food-price-section-gridView{
        position: absolute;
        bottom: 10px;
        right: 10px;

    }

    .detail-card-price-row{
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
        text-align: right;
        line-height: 10px !important;
        align-items: center;
    }

    .detail-card-food-portion-text
    {
        font-size:9px !important;
        line-height: 10px !important;
        font-weight:300;
        color: #949494;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        text-align: left;
    }


    .detail-card-food-item-price
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:9px !important;
        line-height: 10px !important;
        font-weight:300;
        color: #949494;
        text-align: right;
        /* text-transform:uppercase;         */
    }

    .detail-card-now-price
    {

        color: #949494;
        outline-style: thin;
        stroke-width: 2px;
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 2px;
        padding-right: 2px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;
        margin-right: 0px;
        text-align: right !important;
        line-height: 10px !important;
    }

    .detail-card-was-price
    {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-right: 0px !important;
        font-size:9px !important;
        line-height: 10px !important;
        font-weight:300;
        color: #949494;
        text-decoration:none;
        /* text-decoration-color: #FE5800; */
        /* text-align: right !important; */
    }

    .detail-card-food-drink-pairing-text
    {
        background-color: #082a5e ;
        color: rgb(255, 255, 255);
        padding-top: 15px !important;
        padding-bottom: 15px !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
        margin-bottom: 0px;
        font-size:12px;
        font-weight: 400;
        /* line-height:1; */
        text-align: center;
    }

    .detail-card-food-drink-pairing-row{
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        color: #989898;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin: 0px !important;
        justify-content: flex-end;
        align-items: center;
        text-align: right;


    }


/* CSS FOR PAIRD DRINKS ON FOOD DETAIL CARD  */


    .detail-card-food-drink-measure{
        font-size: 8px;
        padding: 0px;
        text-align: left;
        line-height: 1;
    }

    .detail-card-food-drink-unit{
        font-size: 8px;
        padding: 0px;
        text-align: left;
        line-height: 1;
    }

    .detail-card-food-drink-price{
        font-size: 8px;
        padding: 0px;
        text-align: right;
        line-height: 1;
    }


/* FOOD DETAIL CARD END ###################################### */


/* Paired Drink FOOD & DRINK PAIRING - FOOD DETAIL CARD  */

    /* .foodmain .drink-favorite{
        line-height: auto !important;
    } */


.foodmain .foodanddrink-text{
    padding: 0px;
    margin: 0px;

}
.foodanddrink-title
{
    font-size:12px !important;
    line-height: 1 !important;
    padding-bottom: 0px !important;
    /* padding-left: 12px; */
    font-weight:500 !important;
    color: rgb(20, 20, 20) !important;
    text-transform:uppercase !important;
}


.foodanddrink-subtitle{
        font-size:10px !important;
		font-weight: 400 !important;
        text-transform:capitalize !important;
        text-align: justify !important;
        line-height: 1 !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        color: rgb(60, 60, 60) !important;

    }

.foodanddrink-strapline{
    color: rgb(60, 60, 60) !important;
    font-size:8px !important;
    font-weight: 400 !important;
    text-transform:capitalize !important;
    text-align: justify !important;
    /* font-style: italic; */
    line-height: 1 !important;
    padding-left: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;


}

.foodanddrink-description{
        max-block-size: 80% !important;
        color: rgb(48, 48, 48) !important;
        padding-right: 25px !important;
        padding-top: 12px !important;
        padding-bottom: 10px !important;
        padding-left: 0px !important;
        font-size:10px !important;
        font-weight: 300 !important;
        line-height:1 !important;
        text-align: justify !important;
        /* max-height: 100px; */

    }

.foodanddrink-price-measure
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:left;
        color: #949494;
        text-transform:uppercase;
    }

.foodanddrink-price-unit
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:left;
        color: #949494;
        text-transform:uppercase;
    }

.foodmain .foodanddrink-price
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 5px !important;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:right;
        color: #949494;
        text-transform:uppercase;
    }

.foodmain .foodanddrink-price-icon
    {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        text-align: end;
        font-size: 22px;
        color: rgb(20, 57, 220);


    }


    .heart

    .close-icon{
        position:absolute;
        top:15pxs;
        right:15px;
        width: 24px;
        height: 24px;
        z-index: 9;
        font-size: 20px;
    }

    .fborder{
        border:5px solid #FE5800 !important;
    }
    .cheficonFoodGrid{

        position: absolute;
        top: -3px;
        right: 10px;
        width: 46px;
        z-index: 3;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }
    .cheficonFoodDetailCard{

        position: relative;
        top: -3px;
        right: -12px;
        max-width: 55px;
        float: right;
        z-index: 20;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }

.cheficonFoodDetailCard2{

        position: sticky;
        margin-top: -3px !important;
        margin-right: 6px;
        max-width: 50px;
        float: right;
        z-index: 20;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }

    .cheficonFoodList{

        position: absolute;
        top: -3px;
        right: 10px;
        width: 46px;
        z-index: 3;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }
    .cheficonFoodList-loggedin{

        position: absolute;
        top: -3px;
        right: 33px;
        width: 46px;
        z-index: 3;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }
    .srch .v-text-field__details{
    display:none;
    }
    .vue-sticky-el.top-sticky{
        width:100% !important;
        left: 0 !important;
        height:60px;
        margin-left: 0px;
        margin-right: 0px;
        z-index: 201;

    }

    .faint-line{
        color: #ff0000 !important;
    }



    .titledivider{
        position:relative;
        height: 50px;
        background-color:#FE5800 ;
    }
    .titledivider:before{
    position:absolute;
    content:"";
    height:2px;
    background:#f3db05;
    top:50%;
    left:0px;
    right:0px;
    z-index: 1;
    }
    .titlecontent
    {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
    }
    .ovr
    {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999999;

    }
    .foodmain .pt-0{
       padding-right: 0px;
       color: #777777;

    }

    .foodmain .row{
        /* margin-right: 0px !important;
        margin-left: 0px !important; */
        text-decoration: none;
    }

    .foodmain .foodprice{
        font-size: 24px !important;
        color: aqua;
    }
    .foodmain .foodlistcard{
        padding-top: 5px;
        padding-left: 5px;
        padding-right: 5px;
        padding-bottom: 5px;
        background-color: aqua;

    }

    .foodmain .pad-right25{
        padding-right: 25px;
        padding-bottom: 10px;

    }
    .foodmain .noimagecard{
      /* box-shadow: rgba(50, 50, 93, 0.1) !important; */
      box-shadow: 2px 2px 4px 3px #e2e2e2 !important;
    }

    .right-align-text{
        text-align: right;

    }

    .powered-by-juzzap{
        font-size: 8px;
        font-weight: 300;
        color: #FE5800;
        padding-top: 0px;
        padding-bottom: 10px;
        padding-right: 5px;
        text-align: right;
        /* position: absolute; */
    }

    /* ANIMATION STYLING  */


.imagezoomfast .v-image__image.v-image__image--cover{
  animation: beat 30s infinite alternate;
  /* animation:scale 5s forwards; */
  transform-origin:50% 50%;
  transform:scale(1);

}


.imagezoomslow .v-image__image.v-image__image--cover{

  animation: beat 20s infinite alternate;
  /* animation:scale 5s forwards; */
  transform-origin:50% 50%;
  transform:scale(1);

}

@keyframes beat{
	to { transform: scale(1.4); }
}

@keyframes scale {
  100% {
    transform:scale(1.5);
  }
}

/* PULSE ANIMATION  */

.foodmain .pulse-banner {
  /* margin:100px; */
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  /* background: #fe5800; */
  /* cursor: pointer; */
  /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
  animation: pulse .5s;
  animation-iteration-count: 20;
}
.foodmain .pulsex7:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}

.foodmain .pulsex7 {
  /* margin:100px; */
  /* display: block; */
  /* width: 30px; */
  /* height: 30px; */
  border-radius: 50%;
  /* background: #fe5800; */
  /* cursor: pointer; */
  /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
  animation: pulse 2s;
  animation-iteration-count: 7;
}
.pulsex7:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}

/* SQUARE PULSE  MICRO ANIMATION */

.pulseBox {
  /* margin:100px; */
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  /* background: #fe5800; */
  /* cursor: pointer; */
  /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
  animation: pulse 1s;
  animation-iteration-count: 3;
}
.pulsex7:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
      box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
  }
}



/* :class="food.foodstatus=='From Chef' || food.foodstatus=='Feature'? 'backdrop':''" */



    .section-heading-grid {

        border-bottom: 0px !important;
        border-top: 0px !important;
        border-radius: 0px !important;
        box-shadow: none !important;
        border:0px !important;
        text-decoration: none !important;
        background-color: #f0f0f0 !important;
        margin: 0px !important;
        padding-left: -25px !important;
        padding-right: -25px !important;
        width: 100% !important;

    }

    .section-heading-grid .food-title-grid{
        color: #000000 !important;
        font-size: 20px !important;
        font-weight: 800 !important;
        text-align: center !important;

    }

    .section-heading-grid .food-subtitle-grid{
        padding-top: 5px;
        color: #000000 !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        text-align: left !important;
        margin-left: -12px !important;
    }

    .section-heading-grid .food-description-grid{
        color: #000000 !important;
        font-size: 10px !important;
        font-weight: 300 !important;
        text-align: center !important;
        padding-bottom: 10px;
    }

    .spaced{
        display: flex;
        justify-content: space-evenly;
    }


    .tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}


/* SECTION HAEDINGS  */

    .section-heading {

        text-decoration: none !important;
        /* background-color: #d4d4d4 !important; */
        margin: 0px !important;
        border: 2px;
        border-style: solid;
        border-color: red !important;
        padding-top: 0px !important;
        padding-bottom:0px !important;
        border-radius: 1px !important;



    }

    .section-heading .food-title-listView-c{
        color: #525252 !important;
        font-size: 20px !important;
        font-weight: 800 !important;
        text-align: center !important;
        padding-top: 0px;
    }

    .section-heading .food-subtitle-listView-c{
        padding-top: 0px;
        color: #525252 !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        text-align: center !important;
    }

    .section-heading .food-description-listView-c{
        color: #000000 !important;
        font-size: 10px !important;
        font-weight: 300 !important;
        text-align: center !important;
        padding-bottom: 0px;
        margin-bottom: 10px !important;
    }


    .close-menu-right{
    position: fixed;
    right: 0px;
    top: 0px;
    }

    .close-menu-left{
    position: fixed;
    left: 0px;
    top: 0px;
    }


    .edit-item-name{
        font-weight: 600 !important;
        font-size: 10px;
        /* font-size: x-small !important; */
    }
    .course-text-heading{
        font-weight: 600 !important;
        font-size: 14px;
        text-transform: uppercase;
    }

  .flexcenteritem{
      flex-direction: column
  }

  .menuleft{
      /* align-content: flex-start; */
      margin: 0px;
      padding: 0px;
      padding-left: 10px;
      margin-left: 10px;
      align-items: flex-start !important;
      justify-content: start;

  }

    /* Section Heading Grid View  */
/* TOGGEL COMPACT STYLING */

.compact-form {
    transform: scale(0.75);
    transform-origin: right;
}

.shrab {
  padding-top: 20%;
}

.section-spread{
    justify-content: space-between;
}
.stick{
    position: sticky;
}
.compact-cogs-75 {
    transform: scale(0.75);
    transform-origin: right;
    z-index: 4;
    color: #fe5800 !important;
}

.white-compact-cogs-75 {
    transform: scale(0.75);
    transform-origin: right;
    z-index: 4;
    color: rgb(255, 255, 255) !important;
}
.cogtab{
    background-color: #FE5800;
    border-top-left-radius: 5px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 0px;
    width: 50px;
    height: 50px;

}

.compact-cogs-50 {
    transform: scale(0.5);
    transform-origin: right;
    z-index: 4;
}
.compact-cogs-100 {
    transform: scale(1);
    transform-origin: right;
    z-index: 4;
}
.cogsright{
        justify-content: flex-end;
        z-index: 4;
    }
.y-middel-x-centered{

    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid green;
}

.heading-pop-up{

    transform-origin: left top;
    z-index: 10;
    background-color: #fff;
    /* color: white; */
    text-align: center;
}

.quick-edit-card{
    background-color: #ffffff
}

.foodmain .card-text-container{
    display: flex;
    /* border: 4px;
    border-style: dashed;
    border-color: #ed00fd; */

    flex-direction: column;
    justify-content:center;
    align-items: center;
    align-content: center;
    padding-top: 32px;
    padding-bottom: 0px;
    padding-left: 8px;
    padding-right: 8px;

}
.foodmain .card-text-container-gridView{
    position: static;
    display: flex;
    /* border: 4px;
    border-style: dashed;
    border-color: red; */

    flex-direction: column;
    justify-content:center;
    align-items: center;
    align-content: center;
    /* padding-top: 32px; */
    padding-bottom: 0px;
    padding-left: 8px;
    padding-right: 8px;

}

.card-separator-container{
    /* border: 5px;
    border-style: dotted;
    border-color: #00fd4e; */

    flex-direction: column;
    justify-content:center;
    align-items: center;
    align-content: center;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    padding-left: 8px;
    padding-right: 8px;
    text-decoration-color: white !important;

}

.separator-title{
    color: #ffffff !important;
    font-size: 20px !important;
    font-weight: 800 !important;
    text-align: center !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;

}

.separator-subtitle{
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    text-align: center !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
}

.food-separator-title-gridView{
    color: #ffffff !important;
    font-size: 20px !important;
    font-weight: 800 !important;
    text-align: left !important;
    padding-top: 5px !important;
    padding-bottom: 0px !important;

}
.food-separator-subtitle-gridView{
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    text-align: left !important;
    padding-top: 1px !important;
    padding-bottom: 5px !important;
    margin-left: -12px;
    margin-right: -12px;

}

.foodmain .card-content{
    /* Padding-top: 25px !important; */
    /* padding-bottom: 25px !important; */
    /* border: 2px;
    border-style: solid;
    border-color: blue; */
}

.invert-text-colour{
  /* color: white; */
  mix-blend-mode: difference;

}

.strokedcard{
    /* border-color: #FE5800 !important; */

    border-style: outset !important;
    border-width: thick !important;
    border-radius: 0px !important;

}
.lite-border{
    border: 2px;
    border-style: solid;
    border-color: rgb(165, 165, 165) !important;
}
.bbr{
    border: 2px;
    border-style: solid;
    border-color: red !important;
}
.bbrdd{
    border: 2px;
    border-style: dashed;
    border-color: red !important;
}
.bbrdt{
    border: 2px;
    border-style: dotted;
    border-color: red !important;
}
.bgr{
    background-color: #ff0000 !important;

}
.bbg{
    border: 2px;
    border-style: solid;
    border-color: #8bc34a !important;
}
.bbgdd{
    border: 2px;
    border-style: dashed;
    border-color: #8bc34a !important;
}

.bbgdt{
    border: 2px;
    border-style: dotted;
    border-color: #009008 !important;
}
.bgg{
    background-color: #91ff00 !important;

}

.bbb{
    border: 2px;
    border-style: solid;
    border-color: blue;
}
.bbbdd{
    border: 2px;
    border-style: dashed;
    border-color: blue;
}
.bbbdt{
    border: 2px;
    border-style: dotted;
    border-color: blue;
}
.bgb{
    background-color: #00c3ff !important;

}
.bgp{
    background-color: #ff00ff !important;

}
.bgm{
    background-color: #ff4acc !important;

}
.bgc{
    background-color: #3284ff !important;

}
.bgy{
    background-color: #ffff00 !important;

}

.bgzz{
    background-color: #fe5800 !important;

}

.bbbl{
    border: 2px;
    border-style: solid;
    border-color: #000000 !important;
}
.bbbldd{
    border: 2px;
    border-style: dashed;
    border-color: #000000 !important;
}
.bbbldt{
    border: 2px;
    border-style: dotted;
    border-color: #000000 !important;
}
.bbpinkdd{
    border: 2px;
    border-style: dashed;
    border-color: #d107f4 !important;
}
.bbpinkdt{
    border: 2px;
    border-style: dotted;
    border-color: #d107f4 !important;
}
.bgpink{
    background-color: #ff00d4 !important;

}

.true-center{
    display: grid;
    place-items: center;
}


.ex1 .parent {
    display: grid;
    place-items: center;
  }
.v-tabs.top-sticky .v-item-group.v-slide-group{
  height:60px !important;
}

</style>
